/**
 * @license
 * @qwik.dev/core 2.0.0-beta.35-dev+567631a
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as fe, isBrowser as ae } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as ce } from "@qwik.dev/core/preloader";

const he = !1;

const pe = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const $e = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const ye = (t, n, e, s, o = !1) => {
    const r = $e(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const me = (t, n, e) => {
    const s = $e(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const we = (t, n, e) => $e(t, n, e) >= 0;

const be = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const ve = t => typeof t === "object" && t !== null;

const ge = t => Array.isArray(t);

const _e = t => typeof t === "string";

const Se = t => typeof t === "function";

const ke = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = pe(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ee = "<sync>";

const xe = t => typeof t === "function" && typeof t.getSymbol === "function";

const Ga = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const qe = "q:type";

const Te = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Pe = 124;

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Re = "q:renderFn";

const Ae = "q:targetEl";

const Me = "⚡️";

const Ne = "q:slot";

const Ie = "q:s";

const Ce = "q:style";

const je = "style[q\\:style]";

const Oe = je + ",style[q\\:sstyle]";

const Fe = "q:sstyle";

const Le = "q:ctx";

const De = "q:brefs";

const Ve = (t, n) => t["qFuncs_" + n] || [];

const We = "q:base";

const Ue = "q:container-island";

const Xe = "/" + Ue;

const ze = "q:ignore";

const Be = "/" + ze;

const He = "q:container";

const Je = "/" + He;

const Qe = "q:template";

const Ye = "http://www.w3.org/1999/xhtml";

const Ge = "http://www.w3.org/2000/svg";

const Ke = "http://www.w3.org/1998/Math/MathML";

const Ze = "qRender";

const nr = "q:key";

const er = "q:props";

const rr = "q:seq";

const sr = "q:seqIdx";

const ir = "q:p";

const or = "q:ps";

const ur = ":on";

const cr = ":onIdx";

const fr = ":onFlags";

const ar = "q:cursorBoundary";

const hr = ":nearestCursorBoundary";

const dr = ":";

const pr = "dangerouslySetInnerHTML";

const yr = 100;

const mr = t => !!t && typeof t == "object" && typeof t.then === "function";

const wr = (t, n, e) => {
    try {
        const s = t();
        return mr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const br = (t, n) => mr(t) ? t.then(n) : n(t);

const vr = t => {
    throw t;
};

function n(t, n = vr) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!mr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = yr;
    const r = async e => {
        for (;mr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!mr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const gr = t => Me + t;

const _r = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + gr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const Sr = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + kr(t.slice(s, -1));
        }
    }
    return null;
}

const kr = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = Er(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const Er = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const xr = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const qr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const Tr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Pr = t => {
    if (!t) {
        return "";
    }
    if (_e(t)) {
        return t.trim();
    }
    const n = [];
    if (ge(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = Pr(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const Rr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Pr(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (ge(t)) {
                    throw ke(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(Rr(e) + ":" + Ar(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const Ar = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => qr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const Mr = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const Nr = () => ({
    isServer: fe,
    importSymbol(t, n, e) {
        if (fe) {
            const t = Ga(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw ke(6, [ e ]);
        }
        if (!n) {
            throw ke(14, [ e ]);
        }
        if (!t) {
            throw ke(13, [ n, e ]);
        }
        const s = "" + Ir(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Ir = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(We) ?? s, s);
    return new URL(e, o);
};

let Cr = /*#__PURE__ */ Nr();

const jr = t => Cr = t;

const Or = () => Cr;

const Ka = () => Cr.isServer;

const Za = typeof document !== "undefined";

const Fr = !fe && Za;

const Lr = Fr ? document : void 0;

const Dr = Fr && Lr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const Vr = /\.[mc]?js$/;

const Wr = 1e3 / 60;

const Ur = t => {
    let n = Xr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            Vt: t,
            Ct: Vr.test(t) ? 0 : 3,
            Wt: n,
            Ut: 1,
            Xt: performance.now(),
            zt: 0,
            Bt: 0
        }))(t, e);
        Xr.set(t, n);
    }
    return n;
};

const Xr = new Map;

let zr = 0;

const Br = [];

const Hr = Mr(function th() {
    Qr = !1;
    if (!Br.length) {
        return;
    }
    const t = performance.now() + Wr;
    let n = !1;
    for (;Br.length; ) {
        const e = Br[0];
        const s = e.Ut;
        const o = 1 - s;
        if (!(o >= .99 || zr < 25)) {
            break;
        }
        Br.shift();
        ts(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && Br.length && !Qr) {
        Qr = !0;
        Hr();
    }
});

const Jr = Mr(s);

let Qr = !1;

let Yr = !1;

let Gr = !1;

const Kr = [];

const Zr = () => {
    const t = Kr[Kr.length - 1];
    const n = t.Ht;
    if (t.Wt) {
        const e = t.Jt;
        if (e >= t.Wt.length) {
            Kr.pop();
            return !1;
        }
        const s = t.Wt[e];
        t.Jt = e + 1;
        const o = Ur(s.Vt);
        if (o.Ut === 0) {
            return !0;
        }
        const r = 1 - n.Ut;
        let i;
        if (r === 1 || r >= .99) {
            i = Math.min(.01, 1 - s.Qt);
        } else {
            const t = 1 - s.Qt * r;
            const n = s.Yt;
            const e = t / n;
            i = Math.max(.02, o.Ut * e);
            s.Yt = e;
        }
        Kr.push({
            Ht: o,
            Ut: i,
            Gt: t.Gt
        });
        return !0;
    }
    if (t.Gt?.has(n)) {
        Kr.pop();
        return !1;
    }
    const e = n.Ut;
    n.Ut = t.Ut;
    if (e - n.Ut < .01) {
        Kr.pop();
        return !1;
    }
    if (n.Wt?.length) {
        const e = t.Gt || new Set;
        e.add(n);
        t.Gt = e;
        t.Wt = n.Wt;
        t.Jt = 0;
        return !1;
    }
    Kr.pop();
    return !1;
};

function s() {
    if (Gr || !Kr.length) {
        return;
    }
    Yr = !1;
    Gr = !0;
    const t = Fr ? performance.now() + Wr : 0;
    let n = !1;
    for (;Kr.length; ) {
        n = !0;
        const e = Zr();
        if (Fr && e && performance.now() >= t) {
            if (!Yr) {
                Yr = !0;
                Jr();
            }
            break;
        }
    }
    Gr = !1;
    n && Fr && Hr();
}

const ts = t => {
    if (t.Ct >= 2) {
        return;
    }
    zr++;
    const n = performance.now();
    t.zt = n - t.Xt;
    t.Ct = 2;
    const e = Lr.createElement("link");
    e.href = "" + new URL("undefined" + t.Vt, Lr.baseURI);
    e.rel = Dr;
    e.as = "script";
    e.onload = e.onerror = () => {
        zr--;
        const s = performance.now();
        t.Bt = s - n;
        t.Ct = 4;
        e.remove();
        Hr();
    };
    Lr.head.appendChild(e);
};

const ns = (t, n) => {
    const e = Ur(t);
    e && ((t, n) => {
        Kr.unshift({
            Ht: t,
            Ut: n,
            Gt: void 0
        });
    })(e, n);
};

Fr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    ns(e, 0);
                }
            } else {
                ns(t, 0);
            }
            Fr ? Jr() : s();
        })(t);
    }
});

const es = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const rs = ",";

const ss = "2.0.0-beta.35-dev+567631a";

const is = t => t.nodeType === 1;

const os = Symbol();

class ls {
    [os]=void 0;
}

const us = t => t === "foreignObject";

const cs = t => t === "svg" || us(t);

const fs = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== dr && o.setAttribute(e.name, e.value);
    }
    if (s) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? o.appendChild(r.cloneNode()) : c === 1 && o.appendChild(i(r, r.localName, e, s));
        }
    }
    return o;
}

const as = {
    elementNamespace: Ye,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!ll(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && us(ll(t));
    let o = Ye;
    let r = 0;
    const i = typeof n === "string" || Po(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return cs(t);
        }
        if (Po(t)) {
            return cs(ll(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = Ge;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return fs(t);
        }
        if (Po(t)) {
            return fs(ll(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Ke;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? Ge : e ? Ke : Ye;
        r = t.flags & 1536;
    }
    as.elementNamespace = o;
    as.elementNamespaceFlag = r;
    return as;
}

class hs {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [os]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class ds extends hs {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class ps extends ds {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class $s extends hs {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const ys = [];

const ms = [];

function l(t, n) {
    const e = y(n).priority;
    let s = ys.length;
    for (let t = 0; t < ys.length; t++) {
        const n = y(ys[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    ys.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < ys.length; t++) {
        const n = ys[t];
        let e = !1;
        for (let t = 0; t < ms.length; t++) {
            const s = ms[t];
            if (Pl(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ms.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = ys.indexOf(t);
    if (s !== -1) {
        ys.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = ms.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ms.length - 1;
    e !== s && (ms[e] = ms[s]);
    ms.pop();
    n.o--;
    return !0;
}

const ws = new WeakMap;

const bs = ":nodeProps";

const vs = ":nodeDiff";

const gs = ":errorData";

const _s = ":signal";

function p(t, n, e) {
    n.position = e;
    e && on(e) && function s(t, n, e) {
        h(e, t);
        const s = y(e);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return ws.get(t) ?? null;
}

const Ss = Symbol();

class ks {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const Es = Symbol();

const xs = Symbol();

const qs = Symbol();

function m(t, n, e) {
    t[os] || (fe && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(De, new Map) : t[os] = new Map);
    const o = t[os];
    let r = o.get(n);
    if (!r) {
        r = new ks(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const Ts = (t, n) => (e, s) => {
    const o = le();
    o.Ft = m(t, ":");
    o.m = n || void 0;
    return se(o, () => {
        if (Se(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Ul(e)) {
            return e.value;
        }
        if (ve(e) && ru(e)) {
            xn(Zl(e), qs, Kl(e), o.Ft);
            return e;
        }
        throw ke(2);
    });
};

class Ps {
    Kt;
    ct=void 0;
    m=null;
    Zt=null;
    constructor(t, n) {
        this.m = t || Pc()?.m || null;
        this.Kt = n;
    }
    trigger() {
        Hl(this.m, this, this.ct);
    }
    force() {
        Hl(this.m, this, this.ct);
    }
    get untrackedValue() {
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = Pc();
        if (!n) {
            return t;
        }
        this.m === null && (this.m = n.m);
        const e = n.Ft;
        if (e) {
            Xl(this.ct ||= new Set, e);
            zl(e, this);
            fe && Bl(e, this.m);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Kt) {
            this.Kt = t;
            Hl(this.m, this, this.ct);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Kt
        };
    }
}

class Rs extends Ps {
    tn;
    h;
    [os]=void 0;
    constructor(t, n, e = 17) {
        super(t || Pc()?.m, Ss);
        this.tn = n;
        this.h = e;
    }
    invalidate() {
        this.h |= 1;
        const t = le();
        t.m = this.m || void 0;
        const e = n(ie.bind(this, t, this.p));
        e && e.catch(t => {
            this.m ? this.m.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.p();
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = this.tn;
        Wl(t);
        const n = Pc();
        const e = n?.Ft;
        if (n) {
            const t = m(this, ".");
            bn(this.m, t);
            n.Ft = t;
        }
        try {
            const e = t.getFn(n)();
            if (mr(e)) {
                throw ke(29, [ t.dev ? t.dev.file : "", t.ot ]);
            }
            this.h &= -2;
            super.value = e;
        } finally {
            n && (n.Ft = e);
        }
    }
}

class As {
    nn;
    en=null;
    rn=!1;
    sn=!0;
    constructor(t, n, e) {
        this.nn = t;
        if (n !== void 0) {
            this.info = n;
            this.ln = e;
        }
    }
    get track() {
        return this.un ||= Ts(this.nn, this.nn.m);
    }
    get abortSignal() {
        return (this.cn ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.nn.Kt;
        if (t !== Ss) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.fn ||= []).push(t);
    }
}

class Ms extends Rs {
    an=!1;
    hn=void 0;
    dn=null;
    [os]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        if (!s) {
            return;
        }
        const o = s.initial;
        if (o !== void 0) {
            const t = typeof o === "function" ? o() : o;
            this.Kt = t;
        }
        const r = s.concurrency;
        if (r !== void 0 && r >= 0 && r !== 1) {
            this.pn = r;
            this.$n = [];
        }
        const i = s.timeout;
        i && (this.yn = i);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 64);
        s.allowStale === !1 && (this.h |= 128);
        const c = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        c && (this.expires = c);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    get untrackedValue() {
        this.p();
        if (this.dn?.en) {
            if (this.Kt === Ss || fe) {
                throw this.dn?.en;
            }
            return this.Kt;
        }
        if (this.hn) {
            throw this.hn;
        }
        if (fe && this.h & 64 && this.Kt === Ss) {
            throw ke(35);
        }
        return this.Kt;
    }
    set untrackedValue(t) {
        this.Kt = t;
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedLoading = !1;
        this.untrackedError = void 0;
        this.mn = void 0;
        if (this.$n) {
            for (let t = 0; t < this.$n.length; t++) {
                this.$n[t].sn = !1;
            }
        } else {
            this.dn && (this.dn.sn = !1);
        }
        this.wn();
        super.value = t;
        this.bn();
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = Pc();
        if (n && (this.m ||= n.m || null)) {
            const t = n.Ft;
            if (t) {
                Xl(this.$t ||= new Set, t);
                zl(t, this);
                Bl(t, this.m);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.an) {
            this.an = t;
            Hl(this.m, this, this.$t);
        }
    }
    get untrackedLoading() {
        this.p();
        if (fe && this.dn?.en) {
            throw this.dn?.en;
        }
        return this.an;
    }
    get error() {
        const t = this.untrackedError;
        const n = Pc();
        if (n && (this.m ||= n.m || null)) {
            const t = n.Ft;
            if (t) {
                Xl(this.yt ||= new Set, t);
                zl(t, this);
                Bl(t, this.m);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.hn) {
            this.hn = t;
            Hl(this.m, this, this.yt);
        }
    }
    get untrackedError() {
        return this.hn;
    }
    get expires() {
        return this.qt || 0;
    }
    set expires(t) {
        this.wn();
        this.qt = t;
        this.qt && this.vn() && this.bn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.qt && this.vn()) {
            this.wn();
            this.bn();
        }
    }
    get interval() {
        const t = this.qt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    async invalidate(t) {
        if (arguments.length > 0) {
            this.mn = t;
            this.ln = this.ln === void 0 ? 1 : this.ln + 1;
        }
        this.gn(!0, this.h & 128);
    }
    gn(t, n) {
        this.h |= 1;
        this.wn();
        n && (this.Kt = Ss);
        t && (this.ct?.size || this.$t?.size || this.yt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.dn && this._n(this.dn, t);
    }
    wt() {
        if (!(this.h & 32) || this.vn()) {
            return;
        }
        if (!ae) {
            return;
        }
        setTimeout(() => {
            this.vn() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.dn?.en; ) {
            await (this.dn?.en);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (fe && this.h & 64) {
            this.an = !0;
            this.m?.serializationCtx.Tt.add(this);
            return;
        }
        this.wn();
        this.h &= -2;
        const t = this.dn;
        t && this._n(t);
        const n = this.pn === 0 ? Infinity : this.pn ?? 1;
        if (this.$n ? this.$n.length >= n : t?.en) {
            this.h |= 1;
            return;
        }
        const e = this.ln;
        const s = new As(this, this.mn, e);
        this.dn = s;
        this.$n && this.$n.push(s);
        s.en = this.Sn(s);
    }
    async Sn(t) {
        let e = this.tn.resolved;
        if (!e) {
            this.untrackedLoading = !0;
            e = await this.tn.resolve();
            if (t.cn?.signal.aborted) {
                t.en = null;
                return;
            }
        }
        try {
            this.yn && (this.kn = setTimeout(() => {
                const n = Error(`timeout ${this.yn}ms`);
                this.En(t, n);
                t.cn?.abort(n);
            }, this.yn));
            const s = n(e.bind(null, t));
            let o;
            if (mr(s)) {
                this.untrackedLoading = !0;
                o = await s;
            } else {
                o = s;
            }
            t.en = null;
            if (t.sn) {
                const n = this.$n;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].sn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = o;
            }
        } catch (n) {
            t.en = null;
            this.En(t, n);
        }
        if ((() => t === this.dn)()) {
            clearTimeout(this.kn);
            t.ln === this.ln && (this.mn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedLoading = !1;
                this.bn();
            }
        }
    }
    En(t, n) {
        if (t !== this.dn || !t.sn) {
            return;
        }
        t.sn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Ss;
    }
    async xn() {
        this.wn();
        clearTimeout(this.kn);
        const t = this.dn;
        t && this._n(t);
        this.$n ? await Promise.all(this.$n.map(t => t.en)) : await (t?.en);
    }
    wn() {
        if (this.qn !== void 0) {
            clearTimeout(this.qn);
            this.qn = void 0;
        }
    }
    bn() {
        if (fe || !this.qt) {
            return;
        }
        this.wn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.qn = setTimeout(() => this.gn(t, n), this.qt);
        this.qn?.unref?.();
    }
    vn() {
        return !!(this.ct?.size || this.$t?.size || this.yt?.size);
    }
    _n(t, n) {
        if (t.rn) {
            return;
        }
        t.rn = !0;
        t.cn?.abort(n);
        t.en = br(t.en, () => this.Tn(t));
    }
    Tn(t) {
        const n = t.fn;
        const e = t => {
            const n = this.m?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        const s = () => {
            t.en = null;
            n && (n.length = 0);
            const e = this.$n;
            if (e) {
                const n = e.indexOf(t);
                n !== -1 && e.splice(n, 1);
            }
            this.p();
        };
        let o;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const s = n[t]();
                    mr(s) && (o = (o ? o.then(() => s) : s).catch(e));
                } catch (t) {
                    e(t);
                }
            }
        }
        if (o) {
            return o.then(s);
        }
        s();
    }
}

const Ns = Symbol();

const Is = Symbol();

const Cs = Symbol();

const js = Symbol();

const Os = Symbol();

const Fs = Symbol();

const Ls = [];

const Ds = {};

Object.freeze(Ls);

Object.freeze(Ds);

function w(t) {
    return new Proxy({}, new Vs(t));
}

class Vs {
    owner;
    ct=void 0;
    m=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === Ns) {
            return this.owner.constProps;
        }
        if (n === Is) {
            return this.owner.varProps;
        }
        if (n === Cs) {
            return this.owner;
        }
        if (n === js) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = Xs(this.owner, n);
            n in this.owner.varProps && Ws(this, n);
        }
        return s instanceof fi && s.h & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === Cs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === Ns) {
            this.owner.constProps = s;
        } else if (n === Is) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === Ds ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                Us(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && Us(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === Ns || n === Is) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && Ws(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const Ws = (t, n) => {
    const e = Pc();
    e && t.m === null && e.m && (t.m = e.m);
    const s = e?.Ft;
    s && xn(t.owner._proxy, n, t, s);
};

const Us = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ct, n);
    e && Hl(t.m, t, e);
    return !!e;
};

const Xs = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const zs = (t, n) => Bs(t)?.[n] || Hs(t)?.[n] || null;

const Bs = t => {
    if (!t) {
        return null;
    }
    return Is in t ? "children" in t ? {
        ...t[Is],
        children: t.children
    } : t[Is] : t;
};

const Hs = t => {
    if (!t) {
        return null;
    }
    return Ns in t ? t[Ns] : null;
};

const Js = t => t && Is in t;

const Qs = t => (n, ...e) => t.call(null, af(n), ...e);

class Ys extends Rs {
    constructor(t, n) {
        super(t, n, 17);
    }
    Pn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Wl(this.tn);
        const t = Nc(this.tn.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Kt === Ss ? e : this.Kt;
        const r = Cc(() => this.Pn ? s?.(o) || o : n(o), this, ".", this.m);
        this.Pn = !0;
        this.h &= -2;
        const i = this.Pn && r !== "undefined" || r !== this.Kt;
        if (i) {
            this.Kt = r;
            Hl(this.m, this, this.ct);
        }
    }
}

const Gs = (t, n) => new Rs(n?.container || null, t, Ql(n?.serializationStrategy || "always"));

const Ks = (t, n) => new Ms(n?.container || null, t, Ql(n?.serializationStrategy || "always"), n);

const Zs = t => new Ys(null, t);

const ti = t => new Ps(null, t);

const ni = /*#__PURE__*/ Qs(Gs);

const ei = /*#__PURE__*/ Qs(Ks);

const ri = Qs(Zs);

const si = t => t.value;

const ii = (t, n) => t[n];

const oi = t => {
    if (t.length === 1) {
        if (Ul(t[0])) {
            return t[0].Zt ||= new fi(null, si, t, null);
        }
        if (ru(t[0])) {
            return new fi(null, si, t, null);
        }
        return t[0].value;
    }
    return new fi(null, ii, t, null);
};

const li = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!ve(n)) {
        return n[e];
    }
    if (Ul(n)) {
        if (n instanceof fi && n.h & 4) {
            return n;
        }
        return oi(t);
    }
    if (Js(n)) {
        const s = n[Ns];
        const o = n[Is];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return ui(n, t);
        }
    } else {
        const s = Zl(n);
        if (s) {
            const n = s[e];
            return ui(n, t);
        }
    }
    return n[e];
};

const ui = (t, n) => Ul(t) ? t : oi(n);

const ci = (t, n) => {
    const e = li(t, n);
    if (e === Os) {
        return t[n];
    }
    return e;
};

class fi extends Ps {
    ut;
    lt;
    Et;
    h;
    _=void 0;
    [os]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Ss);
        this.ut = e;
        this.lt = n;
        this.Et = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.m && this._) {
                this.m.setHostProp(this._, _s, this);
                cn(this.m, this._, 16);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Hl(this.m, this, this.ct);
        }
    }
    get untrackedValue() {
        this.p();
        return this.Kt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Cc(() => this.lt(...this.ut), this, ".", this.m);
        this.h &= -3;
        const n = t !== this.Kt;
        if (n) {
            this.h |= 2;
            this.Kt = t;
        }
    }
    it() {
        return this.lt === si && Ul(this.ut[0]) ? this.ut[0] : this;
    }
    set value(t) {
        throw ke(31);
    }
    get value() {
        return super.value;
    }
}

class ai {
    data;
    constructor(t) {
        this.data = t;
    }
}

const hi = (t, n) => {
    if (typeof t === "string") {
        const e = Zn(n);
        Gc(Kc(e, t));
    }
    return null;
};

function b(t, n) {
    hi(this, n);
    const e = Yc[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function v(t, n) {
    hi(this, n);
    const e = Yc[0];
    e.value = n.checked;
}

function g(t, n) {
    hi(this, n);
    if (Yc) {
        for (let t = 0; t < Yc.length; t++) {
            const n = Yc[t];
            n instanceof Ms && n.h & 64 && n.p();
        }
    }
}

class di {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || es(n) ? Ds : n;
        this.constProps = !e || es(e) ? null : e;
    }
    get props() {
        return this._proxy ||= w(this);
    }
}

const pi = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const $i = t => t instanceof di;

const yi = "bind:value";

const mi = "bind:checked";

const wi = "passive:";

const bi = "preventdefault:";

const vi = Object.prototype.hasOwnProperty;

const gi = (t, n, e, s, o = !1) => {
    let r = t;
    let i = o;
    if (n.length > 0) {
        if (!i) {
            r = {
                ...r
            };
            i = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete r[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(kr(n.slice(15)))) {
                if (!i) {
                    r = {
                        ...r
                    };
                    i = !0;
                }
                delete r[n];
            }
        }
    }
    return r;
};

const _i = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return kr(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return kr(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return kr(t.slice(11, -1));
    }
    return null;
};

const Si = (t, n, s, o, r = !1) => {
    let i = t;
    let c = r;
    for (let t = 0; t < n.length; t++) {
        const r = n[t];
        const l = _i(r);
        const u = e(r, o.has(l));
        if (u) {
            if (!c) {
                i = {
                    ...i
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(r)) && (i[u] = i[r]);
            delete i[r];
        }
    }
    return i;
};

const ki = (t, n, e, s, o, r, i) => new di(t, n, e, s, o, r, !1, i);

const Ei = (t, n, e, s, o, r, i) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const r = [];
        const i = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(wi)) {
                    r.push(o);
                    t.add(kr(o.slice(8)));
                } else {
                    o.startsWith(bi) ? h.push(o) : _i(o) !== null ? s.push(o) : o === mi ? a = e[o] : o === yi && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(wi)) {
                    i.push(s);
                    t.add(kr(s.slice(8)));
                } else {
                    s.startsWith(bi) ? d.push(s) : _i(s) !== null ? o.push(s) : s === mi ? a = n[s] : s === yi && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = gi(e, r, h, t, l);
            l = l || e !== n;
            e = Si(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = gi(n, i, d, t, u);
            u = u || n !== e;
            n = Si(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && vi.call(n, mi) && delete n[mi];
                if (e && vi.call(e, mi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[mi];
                }
                n.checked = a;
                const t = ef(null, "_chk", v, null, [ a ]);
                if (e && vi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = pi(n, "q-e:input", t) || c;
                }
                c = pi(n, "q-e:input", t) || c;
            } else if (f) {
                n && vi.call(n, yi) && delete n[yi];
                if (e && vi.call(e, yi)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[yi];
                }
                n.value = f;
                const t = ef(null, "_val", b, null, [ f ]);
                if (e && vi.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = pi(n, "q-e:input", t) || c;
                }
                c = pi(n, "q-e:input", t) || c;
            }
        }
        if (n && vi.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && vi.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                r ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new di(t, n, e, s, o, r, c || !0, i);
};

const xi = (t, n, e, s) => Ri(t, n, s);

const qi = (t, n, e, s, o) => Ri(t, {
    ...e,
    ...n
}, o);

const Ti = (t, n, e, s, o, r) => Ri(t, {
    ...e,
    ...n,
    children: s
}, r);

const Pi = t => t.children;

const Ri = (t, n, e, s, o) => Ei(t, n, null, null, 0, e, o);

const Ai = Ri;

const Mi = Ri;

function _(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return Ei(t, n, null, s.children, 0, o);
}

const Ni = t => t.children;

const Ii = (t, n) => new di(Pi, null, null, t.children, 0, n);

const Ci = (t, n, e, s, o) => {
    const r = oe(t.jt, e || n, t);
    if (e) {
        r.Ft = m(e, ":");
        r.m = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Re));
    if (xe(s)) {
        o = o || t.getHostProp(n, er) || Ds;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (mf(s)) {
        const t = s;
        i = () => ie(r, t, [ o || Ds, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => ie(r, t, [ o || Ds ]);
    }
    const l = fe;
    const u = (e = 0) => wr(() => {
        if (!c) {
            t.setHostProp(n, sr, null);
            t.setHostProp(n, cr, null);
        }
        e > 0 && To(n) && wn(t, n);
        return br(i(o), t => br(r.Lt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < yr) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, ur);
        if (o) {
            return function r(t, n, e) {
                const s = x(n);
                let o = n;
                const r = "q-e:qvisible";
                return br(s, n => {
                    const s = !n;
                    let i = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== r && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!i) {
                                    i = T();
                                    const n = fe;
                                    n && t.$(i) || (o = q(o, i));
                                }
                                l = i;
                            }
                            if (l) {
                                l.type === "script" && c === r && (u = "q-d:qinit");
                                k(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (mr(t) && e < yr) {
            return t.then(() => u(++e));
        }
        if (e >= yr) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function k(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const r = e.qrls;
    o == null ? s[n] = r : Array.isArray(o) ? o.push(...r) : s[n] = [ o, ...r ];
    const i = t.varProps[n];
    if (i) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...r ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = xr(n);
    c && E(t, f, "capture");
    l && E(t, f, "preventdefault");
    u && E(t, f, "stoppropagation");
}

function E(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === Ds && (t.varProps = {});
    t.varProps[s] = !0;
}

function x(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if ($i(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (ge(t)) {
            n.push(...t);
        } else {
            if (mr(t)) {
                return br(t, t => x(t));
            }
            if (Ul(t)) {
                return x(t.untrackedValue);
            }
        }
    }
    return null;
}

function q(t, n) {
    if ($i(t)) {
        if (t.type !== Ni && !mf(t.type)) {
            return ki(Ni, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : ge(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return ki(Ni, null, null, [ t, n ], 0, null);
    }
    if (ge(t) && t.length > 0) {
        q(t[0], n);
        return t;
    }
    return t;
}

function T() {
    return new di("script", null, {
        hidden: ""
    }, null, 0, null);
}

const ji = t => ki(Pi, null, {
    [Ie]: ""
}, t.children, 0, t.name ?? "");

const Oi = Symbol();

const Fi = () => null;

const Li = () => null;

const Di = t => t.children;

const Vi = (t, n) => Ri(Ii, {
    children: Ri(Wi, t)
}, n);

const Wi = () => null;

let Ui = null;

let Xi = null;

function P(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Xi || (Xi = t.setAttributeNS);
                    Xi.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            Ui || (Ui = t.setAttribute);
            Ui.call(t, n, e);
        })(t, n, e);
    }
}

function R(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const zi = (t, n = [], e = {}) => {
    let s = null;
    const o = t[Ns];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[Is];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return w(new di(null, r, s, null, 0, null));
};

class Bi {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Hi {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Ji {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Qi {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Yi {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Gi = t => new Bi(t);

const Ki = t => new Hi(t);

const Zi = (t, n) => new Ji(t, n);

const to = (t, n, e) => new Qi(t, n, e);

const no = (t, n, e, s = null, o = !1) => new Yi(t, n, e, s, o);

const eo = () => {
    const t = Ac();
    const n = t._;
    const e = n;
    let s = t.m.getHostProp(e, rr);
    if (s === null) {
        s = [];
        t.m.setHostProp(e, rr, s);
    }
    let o = t.m.getHostProp(e, sr);
    o === null && (o = 0);
    t.m.setHostProp(e, sr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const ro = t => {
    const n = Se(t) && !mf(t) ? se(void 0, t) : t;
    return ti(n);
};

const so = t => io(ro, t);

const io = (t, ...n) => {
    const {val: e, set: s} = eo();
    if (e != null) {
        return e;
    }
    t = Se(t) && !mf(t) ? Nc(t, ...n) : t;
    return s(t);
};

const oo = () => ({
    pending: ti(0),
    version: ti(0)
});

function A(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = I(t.container, n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.pending.value++;
    }
}

function M(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return t.getHostProp(n, ar);
}

function N(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    jo(t, hr, null);
}

function I(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return function e(t) {
        if (!__EXPERIMENTAL__.suspense) {
            return null;
        }
        return Co(t, hr, null) || null;
    }(n) || M(t, n);
}

function C(t, n) {
    __EXPERIMENTAL__.suspense && jo(t, hr, n);
}

function j(t, n, e) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    C(n, e);
    const s = n.dirtyChildren;
    if (!s || s.length === 0) {
        return;
    }
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        j(t, o, M(t, o) || e);
    }
}

const lo = t => {
    if (t.xn) {
        try {
            t.xn();
        } catch (t) {
            ((t, ...n) => {
                pe(!1, t, ...n);
            })(t);
        }
        t.xn = null;
    }
};

function O(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = Mc(e, s));
    const r = o.m;
    const i = o._;
    Lo(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r.k : null;
        const l = Co(i, ir, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = Co(i, or, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return ie(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function F(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Mc(t, n);
    typeof this === "string" && Gc(Kc(e.m, this));
    const s = Yc[0];
    return O(s, t, n, e);
}

function L(t) {
    return t.q === t.T ? t.R : null;
}

function D(t) {
    return t.M || L(t);
}

function V(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = L(t);
    return e === o ? null : e;
}

const uo = Object.prototype.hasOwnProperty;

function W(t, n, e, s, o, r) {
    jo(n, e, r);
    fn(t, no(n.node, e, s, o, (n.flags & 512) !== 0));
}

function U(t, n, e, s) {
    return {
        m: t,
        N: n,
        j: e,
        O: s,
        L: [],
        D: [],
        W: [],
        q: null,
        M: null,
        U: null,
        R: null,
        T: null,
        X: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        K: 0,
        Z: !0,
        tt: !1,
        nt: {
            et: new ai({
                O: s,
                rt: !0
            }),
            st: new ai({
                O: s,
                rt: !1
            })
        }
    };
}

function X(t, n, e, s, o) {
    const r = t ?? U(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.m = n;
        t.N = e;
        t.j = s;
        t.O = o;
        t.nt.et.data.O = o;
        t.nt.st.data.O = o;
        t.D.length = 0;
        t.W.length = 0;
    })(r, n, e, s, o);
    return r;
}

const co = (t, n, e, s, o, r, i) => z(X(i, t, n, o, r), e, s);

const fo = (t, n, e, s, o, r, i, c, l = !1, u) => z(X(u, t, n, i, c), e, s, o, r, l);

function z(t, n, e, s = fl(e), o = null, r = !1) {
    B(t, n, e, s, o, r);
    const i = et(t);
    if (mr(i)) {
        return i.finally(() => {
            rt(t);
        });
    }
    rt(t);
}

function B(t, n, e, s = fl(e), o = null, r = !1) {
    const i = t.tt;
    t.tt = r || i;
    t.q = e;
    t.U = null;
    t.M = s;
    t.R = o;
    t.T = e;
    G(t, n, !0);
    try {
        if (t.q.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.K; ) {
                if (typeof t.Y === "string") {
                    _t(t, t.Y);
                } else if (typeof t.Y === "number") {
                    _t(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if ($i(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            ot(t);
                            pt(t, t.Y, n);
                            const e = t.Y.constProps && uo.call(t.Y.constProps, pr) || uo.call(t.Y.varProps, pr);
                            e ? t.U || st(t, !1) : Q(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === Ni) {
                                ot(t);
                                wt(t, "F", t.Y.key);
                                Q(t, t.Y.children, !0);
                            } else if (n === ji) {
                                ot(t);
                                tt(t) || Q(t, t.Y.children, !0);
                            } else if (n === Et) {
                                Z(t);
                                Q(t, t.Y.children, !0, !1);
                            } else if (n === Li) {
                                it(t);
                            } else if (n === Fi) {
                                it(t);
                            } else {
                                ot(t);
                                bt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        Q(t, t.Y, !1);
                    } else if (Ul(t.Y)) {
                        wt(t, "S", null);
                        const n = t.Y instanceof fi ? t.Y.it() : t.Y;
                        const e = t.M?.[os]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof fi && (s = Nt(e, n));
                        if (!s) {
                            const e = t.U || t.M;
                            Q(t, H(t, () => jc(n, e, ".", t.m)), !0);
                        }
                    } else if (mr(t.Y)) {
                        wt(t, "A", null);
                        t.D.push(t.Y, t.U || t.M);
                    }
                } else {
                    t.Y === Oi || _t(t, "");
                }
                J(t);
            }
            it(t);
            nt(t);
            Y(t);
        }
    } finally {
        t.tt = i;
    }
}

function H(t, e) {
    try {
        return e();
    } catch (s) {
        if (mr(s)) {
            const o = s.then(() => n(e));
            t.D.push(o, t.U || t.M);
            return null;
        }
        throw s;
    }
}

function J(t) {
    if (!t.Z) {
        t.Z = !0;
        return;
    }
    t.G++;
    if (t.G < t.K) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return Y(t);
    }
    t.U !== null ? t.U = null : t.M = V(t, t.M);
}

function Q(t, n, e, s = !0) {
    if (s && (n == null || e && ge(n) && n.length === 0)) {
        st(t);
        return;
    }
    G(t, n, e);
    if (e) {
        const n = t.tt || !!t.U || !fl(t.M);
        t.tt = n;
        t.H = null;
        t.X = null;
        t.B = null;
        t.q = t.U || t.M;
        t.M = fl(t.q);
        t.U = null;
    }
    t.Z = !1;
}

function Y(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.X = t.L.pop();
        t.B = t.L.pop();
        t.U = t.L.pop();
        t.M = t.L.pop();
        t.q = t.L.pop();
    }
    t.Y = t.L.pop();
    t.K = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    J(t);
}

function G(t, n, e) {
    t.L.push(t.J, t.G, t.K, t.Y);
    e && t.L.push(t.q, t.M, t.U, t.B, t.X, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.K = n.length;
        t.J = n;
        t.Y = t.K > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.K = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.K = 1;
    }
}

function K(t) {
    if (t.U) {
        return D(t);
    }
    return V(t, t.M) || L(t);
}

function Z(t) {
    const n = t.Y;
    const e = n.key;
    t.M = Co(t.q, e, n => Uo(t.m.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.U = qo();
        jo(t.U, Ne, e);
        t.U.slotParent = t.q;
        jo(t.q, e, t.U);
    }
}

function tt(t) {
    const n = t.Y;
    const e = Ol(t.q);
    const s = function o(t, n) {
        const e = t.Y;
        const s = e.constProps;
        if (s && typeof s == "object" && uo.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof fi) {
                return jc(e, n, ":", t.m);
            }
        }
        return Xs(e, "name") || "";
    }(t, e);
    const r = Xs(n, ar) || null;
    const i = e ? Co(e, s, null) : null;
    if (i == null) {
        t.U = qo();
        jo(t.U, Ne, s);
        jo(t.U, ar, r);
        j(t.m, t.U, r);
        e && jo(e, s, t.U);
        el(t.N, t.q, t.U, K(t));
        return !1;
    }
    if (i === t.M) {} else {
        const n = i.parent;
        t.U = i;
        jo(t.U, Ne, s);
        jo(t.U, ar, r);
        j(t.m, t.U, r);
        e && jo(e, s, t.U);
        nl(t.N, t.U);
        el(t.N, t.q, t.U, K(t));
        n && Po(n) && !n.firstChild && ll(n) === Qe && il(t.N, n.parent, n, !0);
    }
    return !0;
}

function nt(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            Tt(t.m, t.N, e, t.j);
            il(t.N, t.q, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function et(t) {
    for (;t.D.length; ) {
        const n = t.D.shift();
        const e = t.D.shift();
        if (mr(n)) {
            return n.then(n => {
                B(t, n, e);
                return et(t);
            }).catch(n => {
                t.m.handleError(n, e);
                return et(t);
            });
        }
        B(t, n, e);
    }
    if (t.W.length) {
        const n = t.W.splice(0);
        return Promise.all(n).then(() => et(t));
    }
}

function rt(t) {
    t.N = null;
    t.j = null;
}

function st(t, n = !0) {
    const e = t.M && fl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            Tt(t.m, t.N, s, t.j);
            s = s.nextSibling;
        }
        ol(t.N, t.M, e, n);
    }
}

function it(t) {
    const n = L(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = V(t, t.M);
            if (t.q === n.parent) {
                Tt(t.m, t.N, n, t.j);
                il(t.N, t.q, n, !0);
            }
        }
    }
}

function ot(t) {
    if (t.M !== null && Mo(t.M)) {
        const n = t.M;
        t.M = V(t, t.M);
        il(t.N, t.q, n, !0);
    }
}

function lt(t, n, e) {
    if (Ul(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw ke(15, [ e ]);
}

function ut(t, e, s, o, r) {
    return n(() => jc(o, e, s, t, r));
}

function ct(t, n, e, s, o) {
    const i = t.O;
    const c = s.then(t => P(n, e, r(e, t, i), o));
    t.W.push(c);
}

function ft(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(He, "html");
    }
}

function at(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ht(t, n, e, s) {
    const i = function c(t, n) {
        const e = sl(t.q, !0);
        const s = o(e, n);
        const r = document;
        const i = s.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(s.elementNamespace, n);
        t.U = ko(i, n);
        t.U.flags |= s.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.U;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (Sr(n)) {
                dt(n, o, i, l, t);
                continue;
            }
            if (n === "ref" && lt(o, i, s)) {
                continue;
            }
            Ul(o) && (o = ut(t.m, t.U, n, o, t.nt.et));
            if (mr(o)) {
                ct(t, i, n, o, u);
                continue;
            }
            if (n === pr) {
                ft(i, o);
                continue;
            }
            if (e === "textarea" && n === "value" && at(i, o)) {
                continue;
            }
            P(i, n, r(n, o, t.O), u);
        }
    }
    const a = n.key;
    a && (t.U.key = a);
    if (t.O) {
        const e = uo.call(n.varProps, "class") || n.constProps && uo.call(n.constProps, "class");
        e || i.setAttribute("class", t.O);
    }
    Yo(t.N, t.q, t.U, D(t));
}

function dt(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(O.bind(null, n));
                }
            } else {
                e && s.push(O.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = O.bind(null, n));
    }
    t.charAt(2) !== "e" && Oo(o.N, s, t, "");
    (function i(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, r);
}

function pt(t, n, e) {
    if (t.tt) {
        ht(t, n, e, null);
    } else {
        const s = t.M && Po(t.M);
        const o = s && e === ll(t.M);
        const r = n.key;
        const i = s && t.M.key;
        if (o && r === i) {
            yt(t, e, r);
        } else {
            const s = $t(e, r);
            mt(t, e, r, s, t.q) && ht(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.U || t.M;
    s && function r(t, n, e, s) {
        t.tt || Lo(t.m, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && uo.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof fi && e instanceof fi && Mt(i, e)) {
                        continue;
                    }
                    ao(t, n, r, i, s);
                }
            } else {
                i != null && ao(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                uo.call(e, r) || r.charAt(0) === ":" || Sr(r) || ao(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const ao = (t, n, e, s, o) => {
    if (Sr(e)) {
        dt(e, s, n.node, n, t);
        return;
    }
    if (e === ir || e === or) {
        jo(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (lt(s, t, o)) {
            return;
        }
    }
    const i = n[os]?.get(e);
    if (Ul(s)) {
        const o = s instanceof fi ? s.it() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && bn(t.m, i);
        const r = n;
        s = ut(t.m, r, e, o, t.nt.st);
    } else {
        i && bn(t.m, i);
    }
    if (mr(s)) {
        const o = n;
        const i = s.then(n => {
            W(t.N, o, e, n, t.O, r);
        });
        t.W.push(i);
        return;
    }
    W(t.N, n, e, s, t.O, r);
};

function $t(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function yt(t, n, e) {
    const s = $t(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function mt(t, n, e, s, o, r) {
    t.U = function i(t, n, e) {
        let s = null;
        if (t.X === null) {
            const o = t.M;
            if (o) {
                const s = Po(o) ? ll(o) : null;
                const r = St(o) || kt(o, t.m.k);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.X = new Map;
            t.B = [];
            const r = L(t);
            let i = t.M;
            for (;i && i !== r; ) {
                const o = Po(i) ? ll(i) : null;
                const r = St(i) || kt(i, t.m.k);
                s === null && r == e && o == n ? s = i : r === null ? t.B.push(o, i) : t.X.set($t(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = $t(n, e);
            const r = t.X.get(o);
            if (r) {
                s = r;
                t.X.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = Po(t.M) ? ll(t.M) : null;
                    const e = St(t.M) || kt(t.M, t.m.k);
                    if (e != null) {
                        const s = $t(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.X?.delete(s);
                    }
                }
                return;
            }
            const e = L(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = Po(s) ? ll(s) : null;
                const e = St(s) || kt(s, t.m.k);
                if (e != null) {
                    const o = $t(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.X?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.U) {
        s || el(t.N, o, t.U, D(t));
        t.M = t.U;
        t.U = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (r && t.M) {
                const n = St(t.M) || kt(t.M, t.m.k);
                if (n != null) {
                    const e = Po(t.M) ? ll(t.M) : null;
                    const s = $t(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && el(t.N, o, n, D(t));
            t.M = n;
            t.U = null;
            return !1;
        }
    }
    return !0;
}

function wt(t, n, e) {
    const s = n === "F";
    const o = St(t.M);
    const r = t.M && No(t.M);
    const i = r && o === e && (!s || !!e);
    if (i) {
        yt(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Go(t.N, t.q, t.U = qo(), K(t));
        t.U.key = e;
        return;
    }
    if (mt(t, null, e, $t(null, e), t.q, !0)) {
        Go(t.N, t.q, t.U = qo(), K(t));
        t.U.key = e;
    }
}

function bt(t, n) {
    const e = n[yf];
    let s = t.U || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ot;
        const l = kt(s, t.m.k);
        const u = o.key || c;
        const f = St(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                yt(t, null, u);
            } else {
                vt(t, s, i, n);
                s = t.U;
                r = !0;
            }
        } else {
            if (mt(t, null, u, u, t.q)) {
                vt(t, s, i, n);
                r = !0;
            }
            s = t.U || t.M;
        }
        if (s) {
            const e = Co(s, er, t.m.k);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = xt(n[Ns], e[Ns], e[js], s, !1);
                        o ||= t;
                        const r = xt(n[Is], e[Is], e[js], s, !0);
                        o ||= r;
                        e[Cs] = n[Cs];
                    } else if (n) {
                        jo(t, er, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.m);
                if (c && o.key == null) {
                    vt(t, s, i, n);
                    s = t.U;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                jo(s, Re, i);
                s.flags &= -33;
                cn(t.m, s, 4, t.j);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new di(Et, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (R(n)) {
                            const t = n;
                            ye(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = ($i(n) && Xs(n, Ne) || "") + "";
                const i = $e(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            Q(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = St(s);
        const i = e === r;
        const c = kt(s, t.m.k);
        const l = c == null;
        if (s && !l || !s) {
            gt(t);
            s = t.U;
        } else if (i) {
            yt(t, null, e);
        } else {
            mt(t, null, e, e, t.q) && gt(t);
            s = t.U || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!No(e) || Co(e, Re, null) === null); ) {
                e = e.parent || Ol(e);
            }
            const r = Ci(t.m, s, e || t.m.rootVNode, n, o.props);
            t.D.push(r, s);
        }
    }
}

function vt(t, n, e, s) {
    n && wn(t.m, n);
    Go(t.N, t.q, t.U = qo(), K(t));
    const o = t.Y;
    jo(t.U, Re, e);
    jo(t.U, er, s);
    t.U.key = o.key;
}

function gt(t) {
    Go(t.N, t.q, t.U = qo(), K(t));
    const n = t.Y;
    jo(t.U, er, n.props);
    n.key && (t.U.key = n.key);
}

function _t(t, n) {
    if (t.M !== null) {
        const e = Cl(t.M);
        if (e === 3) {
            if (n !== ul(t.M)) {
                cl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Yo(t.N, t.q, t.U = xo(document.createTextNode(n), n), D(t));
}

function St(t) {
    if (t == null || Mo(t)) {
        return null;
    }
    return t.key;
}

function kt(t, n) {
    if (t == null || Mo(t)) {
        return null;
    }
    const e = Co(t, Re, n);
    return e ? e.ot : null;
}

function Et() {}

function xt(t, n, e, s, o = !0) {
    if (qt(t) && qt(n)) {
        return !1;
    }
    e.m = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === De) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = Us(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === De) {
                continue;
            }
            if ((!t || !uo.call(t, s)) && o) {
                delete n[s];
                const t = Us(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function qt(t) {
    if (!t) {
        return !0;
    }
    return es(t);
}

function Tt(t, n, e, s = null) {
    let o = e;
    const r = s && on(s) ? y(s) : null;
    if (Mo(e)) {
        At(o);
        return;
    }
    let i = null;
    for (;;) {
        r && o !== s && on(o) && a(t, r, o);
        const c = o.flags;
        if (c & 3) {
            wn(t, o);
            At(o);
            const r = c & 2 && Co(o, Re, null) !== null;
            if (r) {
                const e = t.getHostProp(o, rr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (ve(r)) {
                            const n = Vl(r);
                            if (n && r.h & 1) {
                                r.h |= 16;
                                cn(t, o, 64, s);
                                continue;
                            }
                            (r instanceof Ps || ru(r)) && wn(t, r);
                            (n || r instanceof Ms) && lo(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    const e = Object.keys(r);
                    for (let o = 0; o < e.length; o++) {
                        const i = e[o];
                        if (R(i)) {
                            const e = r[i];
                            if (e) {
                                r[i] = null;
                                const o = typeof e === "string" ? Uo(t.rootVNode, e) : e;
                                let c = fl(o);
                                for (;c; ) {
                                    Tt(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                Rt(t, n, o);
                            }
                        }
                    }
                }
            }
            const i = Io(o);
            if (i) {
                if (o === e) {
                    const n = fl(o);
                    if (n) {
                        dn(n);
                        return;
                    }
                    Pt(t, o);
                }
            } else {
                const t = fl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && At(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        i = o.parent;
        for (;i; ) {
            if (i === e) {
                return;
            }
            const t = i.nextSibling;
            if (t) {
                o = t;
                break;
            }
            i = i.parent;
        }
        if (i == null) {
            return;
        }
    }
}

function Pt(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, Ne);
    e != null && t.getHostProp(n.slotParent, e) === n && jo(n.slotParent, e, null);
}

function Rt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && ll(s) === Qe) {
            Pt(t, e);
            il(n, s, e, !0);
        }
    }
}

function At(t) {
    t.flags |= 32;
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.lt === t.lt && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ut, t.ut);
}

function Nt(t, n) {
    if (!(n instanceof fi)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof fi && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

function It(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Ct(t, n, e, s, o, r) {
    const i = Array(r - o + 1);
    for (let c = o; c <= r; c++) {
        const r = n[c] ?? (n[c] = e(t[c], c));
        i[c - o] = It(t[c], c, r, s);
    }
    return i;
}

function jt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Ot(t, n, e, s, o, r, i) {
    const c = t;
    const l = o.length;
    const u = fl(e);
    const f = U(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return fo(c, n, Ct(o, a, r, i, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        ol(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= r(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return fo(c, n, Ct(o, a, r, i, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        ol(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= r(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const m = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== m; ) {
            const s = t.nextSibling;
            il(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = m;
        return fo(c, n, Ct(o, a, r, i, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= r(o[t], t);
    }
    const w = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function g(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const _ = [];
    const k = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            k.set(o, _.length);
            _.push(s);
        } else {
            il(n, e, s, !0);
        }
    }
    const S = new Int32Array(w);
    S.fill(-1);
    const E = [];
    const x = [];
    for (let t = 0; t < w; t++) {
        const n = k.get(a[h + t]);
        if (n !== void 0) {
            S[t] = n;
            x.push(t);
            E.push(n);
        }
    }
    const q = new Uint8Array(w);
    const T = function P(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let r = 0;
            let i = e.length;
            for (;r < i; ) {
                const s = r + i >> 1;
                t[e[s]] < n ? r = s + 1 : i = s;
            }
            r > 0 && (s[o] = e[r - 1]);
            r === e.length ? e.push(o) : e[r] = o;
        }
        const o = [];
        let r = e[e.length - 1];
        for (;r !== -1; ) {
            o.push(r);
            r = s[r];
        }
        o.reverse();
        return o;
    }(E);
    for (let t = 0; t < T.length; t++) {
        q[x[T[t]]] = 1;
    }
    let R = d;
    let M = m;
    const A = () => {
        for (;R >= h; ) {
            const t = R - h;
            if (q[t] === 1) {
                M = _[S[t]];
                R--;
                continue;
            }
            const r = S[t];
            if (r !== -1) {
                const t = _[r];
                const s = M === null ? e.lastChild === t : t.nextSibling === M;
                s || el(n, e, t, M);
                M = t;
                R--;
                continue;
            }
            let l = R;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (q[t] === 1 || S[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = R - l + 1;
            const d = fo(c, n, Ct(o, a, null, i, l, R), e, M, M, s, null, !0, f);
            return br(d, () => {
                const t = jt(e, M, u);
                M = t;
                R = l - 1;
                return A();
            });
        }
    };
    return A();
}

function Ft(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, rr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let r = 0; r < s.length; r++) {
        const i = s[r];
        if (i instanceof Dl) {
            const s = i;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.h & 8);
                const i = Ll(s, n, t);
                mr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function Lt(t, n) {
    const e = t.props ||= {};
    e[vs] = n;
}

function Dt(t, n) {
    t.dirty &= -257;
    const e = function s(t) {
        const n = t.props;
        return n?.[gs] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[gs] = n;
    })(t, null);
    const r = t;
    const i = r.parent;
    const c = r.nextSibling;
    const l = Jo(n, document, r, e);
    const u = Po(r) && i || r;
    const f = u === r ? null : c;
    Yo(n, u, l, f);
    t.dirty &= -33;
    t.dirtyChildren = null;
}

function Vt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[vs];
    }(t);
    if (!r) {
        return;
    }
    Lt(t, null);
    Ul(r) && (r = r.value);
    return co(n, e, r, o, s, null);
}

function Wt(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, Re);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, er) || null;
    const l = wr(() => Ci(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Fe);
        return n(() => co(e, s, t, r, o, _r(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (mr(l)) {
        return l;
    }
    return;
}

function Ut(t, n, e, s, o, r = null) {
    n.push(no(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Xt(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[bs] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Ul(e) && (e = e.value);
        const r = s.isConst;
        Ut(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[bs];
    })(t);
}

function zt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, rr);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof Dl && n.h & 16) {
            n.h &= -17;
            const t = n;
            lo(t);
        }
    }
}

function Bt(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, _s);
    if (!s) {
        return;
    }
    const o = s.ct;
    const r = le();
    r.m = e;
    return br(n(() => se.call(s, r, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Hl(e, s, o);
        }
    });
}

function Ht(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, er) || null;
    if (!r) {
        return;
    }
    let i = zs(r, "items");
    Ul(i) && (i = Nc(i));
    const c = zs(r, "key$");
    const l = zs(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Ot(n, e, o, s, i, u, f);
    }
    return br(c.resolve(), t => br(l.resolve(), r => Ot(n, e, o, s, i, t, r)));
}

let ho = null;

const po = (t, n, e) => {
    ho || (ho = t.insertBefore);
    ho.call(t, n, e);
};

function Jt(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                po(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                po(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Qi) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            po(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof Bi) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Hi) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Ji) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Yi) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if ($o(t, e)) {
                t[e] = yo(o);
            } else if (e === pr) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(He, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : P(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const $o = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const yo = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const mo = (t => () => queueMicrotask(t))(Gt);

const bo = Mr(Gt);

let vo = !1;

function Qt() {
    if (!vo) {
        vo = !0;
        mo();
    }
}

function Yt() {
    if (!vo) {
        vo = !0;
        bo();
    }
}

function Gt() {
    vo = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (Kt(e, n)) {
            Yt();
            return;
        }
    }
}

function Kt(t, n) {
    const e = fe;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const r = s.container;
    if (!t.dirty) {
        Zt(r, t, s, e);
        return;
    }
    const i = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 511)) {
            __EXPERIMENTAL__.suspense && N(l);
            p(r, s, en(l, t, r));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 64) {
                zt(l, r);
            } else if (l.dirty & 32) {
                const n = nn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -512;
            p(r, s, en(l, t, r));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Ft(l, r, s);
            } else if (l.dirty & 2) {
                e = Vt(l, r, i, t);
            } else if (l.dirty & 4) {
                e = Wt(l, r, i, t);
            } else if (l.dirty & 128) {
                e = Ht(l, r, i, t);
            } else if (l.dirty & 8) {
                Xt(l, i);
            } else if (l.dirty & 16) {
                e = Bt(l, r);
            } else if (l.dirty & 32) {
                const n = nn(r, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 256 && Dt(l, i);
            }
        } catch (t) {
            r.handleError(t, l);
        }
        if (e && mr(e)) {
            A(s, l);
            const n = e;
            s.promise = n;
            c(t, r);
            const o = l;
            n.catch(t => {
                s.promise === n && r.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, r);
                Qt();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    Zt(r, t, s, e);
}

function Zt(t, n, e, s) {
    if (!(n.dirty & 511)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Jt(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (let n = 0; n < e.length; n++) {
                    const o = e[n];
                    const r = Ll(o, t, o.ft);
                    mr(r) && (s = s ? s.then(() => r) : r);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function r(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.pending.value = Math.max(0, e.pending.value - 1);
                e.version.value++;
            }
        })(e);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                tn(t);
            });
            return;
        }
        tn(t);
    }
}

function tn(t) {
    t.ht();
}

function nn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        N(e);
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = en(o[0], s, t);
    p(t, n, i);
    return i;
}

function en(t, n, e) {
    if (t === n) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 32 ? s = t.slotParent : t.parent && t.parent.dirty & 32 && (s = t.parent);
    if (!s) {
        if (n.dirty & 511) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let r = s.nextDirtyChildIndex;
    const i = o.length;
    let c = i;
    for (;c-- > 0; ) {
        const t = o[r];
        if (t.dirty & 511) {
            if (e && rn(e, t)) {
                r++;
                r === i && (r = 0);
                continue;
            }
            s.nextDirtyChildIndex = (r + 1) % i;
            return t;
        }
        r++;
        r === i && (r = 0);
    }
    s.dirty &= -33;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && N(s);
    return en(s, n, e);
}

function rn(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    if (!n.props || !(ar in n.props) || !t.getHostProp(n, ar)) {
        return !1;
    }
    on(n) || sn(t, n, 0);
    return !0;
}

function sn(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        ws.set(t, n);
    })(n, s);
    const r = n;
    r.flags |= 256;
    l(t, r);
    Qt();
    return r;
}

function on(t) {
    return (t.flags & 256) !== 0;
}

function ln(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(bs);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Ul(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 16 && Bt(n, t);
        n.dirty &= -512;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(rr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const r = e[o];
                if (r instanceof Dl) {
                    const e = r;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Ll(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        mr(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, er) || null;
            if (!s) {
                return;
            }
            let o = zs(s, "items");
            Ul(o) && (o = Nc(o));
            const r = await zs(s, "key$").resolve();
            const i = await zs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -508;
    if (e) {
        return e;
    }
}

const go = [];

function un(t) {
    for (let n = 0; n < go.length; n++) {
        const e = go[n];
        const s = go[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function cn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return fe;
    }()) {
        const e = ln(t, n);
        mr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 511;
    if ((i ? o & 511 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function e(t, n, s) {
            go.push(n);
            let o = M(t, n);
            let r = n.slotParent || n.parent;
            for (;r; ) {
                const e = r.dirty & 511;
                const i = on(r);
                __EXPERIMENTAL__.suspense && (o ||= M(t, r) || (e ? I(t, r) : null));
                if (r === s || e) {
                    C(n, o);
                    un(r);
                    if (i) {
                        const t = y(r);
                        t.position !== r && (t.position = n);
                    }
                    go.length = 0;
                    return;
                }
                if (i) {
                    const t = y(r);
                    t.position !== r && (t.position = n);
                }
                go.push(r);
                r = r.slotParent || r.parent;
            }
            go.length = 0;
            ((t, ...n) => {
                const e = pe(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(t, n, s);
        return;
    }
    if (c && c.dirty & 511) {
        C(n, M(t, n) || I(t, c));
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (on(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        on(n) ? C(n, M(t, n)) : function l(t, n) {
            go.push(n);
            let e = __EXPERIMENTAL__.suspense ? M(t, n) : null;
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const o = on(s);
                __EXPERIMENTAL__.suspense && (e ||= M(t, s) || (o ? I(t, s) : null));
                if (o) {
                    C(n, e);
                    un(s);
                    go.length = 0;
                    return !0;
                }
                go.push(s);
                s = s.slotParent || s.parent;
            }
            C(n, e);
            go.length = 0;
            return !1;
        }(t, n) || sn(t, n, 0);
    }
}

function fn(t, n) {
    t.push(n);
}

const _o = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const So = t => {
    let n = null;
    return e => {
        n || (n = _o(e, t));
        return n.call(e);
    };
};

const ko = (t, n, e = null) => {
    const s = new ps(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const Eo = t => {
    const n = new ps(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const xo = (t, n) => {
    const e = new $s(-4084, null, null, null, null, t, n);
    return e;
};

const qo = () => {
    const t = new ds(null, -4094, null, null, null, null, null, null);
    return t;
};

const To = t => t instanceof hs;

const Po = t => (t.flags & 1) === 1;

const Ro = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const Ao = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const Mo = t => (t.flags & 4) === 4;

const No = t => (t.flags & 2) === 2;

const Io = t => {
    const n = t.flags;
    return (n & 2) === 2 && Co(t, Ne, null) !== null;
};

const nh = t => t;

const Co = (t, n, e) => {
    if (Po(t) || No(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const jo = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const Oo = (t, n, e, s, o = null) => {
    if (Po(n)) {
        jo(n, e, s);
        fn(t, no(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Fo = t => {
    if (t.key) {
        return;
    }
    const n = $l(t.node, dr);
    n && (t.key = n);
};

const Lo = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (Sr(c)) {
                an(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== dr && c) {
                if (c.startsWith(He)) {
                    const t = i.value;
                    t === "html" ? jo(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && jo(e, "value", s.value);
                } else {
                    const t = i.value;
                    jo(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        Co(e, ir, null) === null && Co(e, or, null) === null || (n.flags |= 64);
    }
};

const Do = t => {
    if (t.vt === "_run") {
        const n = t.getCaptured()?.[0];
        if (xe(n)) {
            return n;
        }
    }
    return t;
};

function an(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = Do(An(i[t], e));
        c.push(O.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function hn(t, n, e) {
    let s = fl(n);
    for (;s; ) {
        if (Mo(s)) {
            Wo(t, s);
            e(s, n);
        } else {
            Po(s) ? e(s, n) : hn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function dn(t) {
    let n = t;
    if (Mo(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = fl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Vo = (t, n, e) => {
    let s = t;
    for (;e && s && No(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !No(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !No(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (Mo(t) && e && Po(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && Al(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Wo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = rl(n, !0);
        const o = e.node;
        const r = El(s);
        let i = Vo(n, !1, !0);
        const c = Vo(n, !0, !0);
        const l = o || (c && Po(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && Mo(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                fn(t, to(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = Vo(i, !1, !0);
        }
        i = n;
        for (;i && Mo(i); ) {
            const n = Vo(i, !0, !0);
            const e = !n || !Mo(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    fn(t, Zi(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    fn(t, to(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const Uo = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (To(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = Bo(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = Ho(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = Xo(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const Xo = (t, n) => {
    let e = fl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const zo = [];

const Bo = (t, n) => {
    let e = fl(t);
    for (;e && (!(e instanceof ps) || e.node !== n); ) {
        if (No(e)) {
            const t = e.nextSibling;
            const n = fl(e);
            if (n) {
                t && zo.push(t);
                e = n;
            } else {
                e = t || (zo.length ? zo.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || zo.pop();
        }
    }
    for (;zo.length; ) {
        zo.pop();
    }
    return e;
};

const Ho = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Jo = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const r = ko(o, "errored-host");
    if (Ro(e)) {
        el(t, r, e, null);
    } else {
        const n = [];
        hn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            el(t, r, n[e], null);
        }
    }
    return r;
};

const Qo = Jt;

const Yo = (t, n, e, s) => {
    const o = Po(n);
    o && al(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    tl(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : rl(n, !1);
    l && !c && fn(t, to(i, l, Ko(t, n, s)?.node ?? null));
    Zo(n, e, s);
    c && (e.flags |= 32);
};

const Go = (t, n, e, s) => {
    const r = Po(n);
    r && al(n);
    const c = e.parent;
    if (e === s) {
        if (c) {
            return;
        }
        s = null;
    }
    tl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[Ae] : null;
    const f = u ? null : r ? n : sl(n, !1);
    const a = u || f?.node;
    const h = Ko(t, n, s);
    const d = h?.node ?? null;
    const p = Io(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = sl(n, !1);
        const c = Ko(t, n, s)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        hn(t, e, n => {
            if (Mo(n)) {
                fn(t, to(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, s, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (Po(c)) {
                                e = c.node;
                                const t = ll(c);
                                const l = c.parent;
                                const h = u == null ? n : l && sl(l, !0);
                                if (h) {
                                    const t = o(h, ll(c));
                                    s = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = fl(c);
                                a = i(e, t, s, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (dl(e)) {
                                    const t = te(e);
                                    if (t) {
                                        const n = fl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                fn(t, to(n.node, a, c));
            }
        });
    } else {
        a && !l && hn(t, e, n => {
            fn(t, to(n.node, a, d));
        });
    }
    Zo(n, e, s);
    l && (e.flags |= 32);
};

const Ko = (t, n, e) => {
    let s = null;
    e == null ? No(n) && (s = Vo(n, !0, !1)) : s = No(e) ? Vo(e, !0, !0) : e;
    s && Mo(s) && Wo(t, s);
    return s;
};

const Zo = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const tl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && il(t, n, s, !1);
};

const nl = (t, n) => {
    let e = n;
    for (;e && No(e); ) {
        e = e.lastChild;
    }
    e && Mo(e) && (e.flags & 8) === 0 && Wo(t, e);
};

const el = (t, n, e, s) => {
    Ro(e) ? Yo(t, n, e, s) : Go(t, n, e, s);
};

const rl = (t, n) => {
    for (;t && !Po(t); ) {
        if (t.flags & 2048) {
            return t.props?.[Ae];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const sl = (t, n) => {
    for (;t && !Po(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const il = (t, n, e, s) => {
    Mo(e) && Wo(t, e);
    if (s) {
        const s = Co(n, pr, null) !== null;
        if (s) {
            return;
        }
        Ro(e) ? fn(t, Gi(e.node)) : hn(t, e, n => {
            fn(t, Gi(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const ol = (t, n, e, s = !0) => {
    const o = rl(n, !0);
    if (o && s) {
        if (Ro(n)) {
            fn(t, Ki(n.node));
        } else {
            const e = sl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? fn(t, Ki(o)) : hn(t, n, n => {
                fn(t, Gi(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const ll = t => {
    const n = nh(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = kl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = Sl(t);
            switch (n) {
              case Ge:
                return 512;

              case Ke:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const ul = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const cl = (t, n, e) => {
    Wo(t, n);
    n.text = e;
    fn(t, Zi(n.node, e));
};

const fl = t => {
    if (Mo(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = al(t));
    return n;
};

const al = n => {
    const e = nh(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && dl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = _l(e);
            const o = El(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                Fo(n);
                if (o) {
                    if (o.charCodeAt(0) === Pe && o.charCodeAt(1) === Pe) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = xl(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = jl(t);
                            return !n || n && mn(t);
                        };
                        let p = null;
                        ql(e, ($, y, m, w, b) => {
                            if (Ml($())) {
                                for (;d(o); ) {
                                    o = bl(o);
                                    if (!o) {
                                        throw ke(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;Ml($()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = Eo(o);
                                    Fo(n);
                                    u(n);
                                    o = bl(o);
                                    for (;jl(o) && mn(o); ) {
                                        o = bl(o);
                                        if (!o && t > 0) {
                                            throw ke(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                jo(n, Fe, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                jo(n, Re, y());
                            } else if ($() === 61) {
                                h || (h = Zn(s));
                                const t = y();
                                h.Rn(parseInt(t), n);
                            } else if ($() === 62) {
                                jo(n, er, y());
                            } else if ($() === 64) {
                                const e = w(b + 1) === Pe;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURIComponent(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if ($() === 91) {
                                jo(n, rr, y());
                            } else if ($() === 94) {
                                jo(n, sr, y());
                            } else if ($() === 96) {
                                h || (h = Zn(s));
                                $n(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Zn(s));
                                n.slotParent = Uo(h.rootVNode, y());
                            } else if ($() === 93) {
                                jo(n, Le, y());
                            } else if ($() === 123) {
                                m();
                                u(qo());
                                Il.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if ($() === Pe) {
                                const e = t(y());
                                const s = t(y());
                                jo(n, e, s);
                            } else if ($() === 125) {
                                m();
                                n.lastChild = c;
                                r = Il.pop();
                                l = Il.pop();
                                c = Il.pop();
                                i = Il.pop();
                                n = Il.pop();
                            } else if ($() === 126) {
                                const e = t(y());
                                jo(n, Ne, e);
                            } else {
                                for (;jl(o) && mn(o); ) {
                                    o = bl(o);
                                }
                                const t = o && yl(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;Nl($()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new $s(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Zn(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return xl(n, s);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let hl = null;

const dl = t => {
    hl || (hl = t.hasAttribute);
    return hl.call(t, He);
};

let pl = null;

const $l = (t, n) => {
    pl || (pl = t.getAttribute);
    return pl.call(t, n);
};

const yl = So("nodeType");

const ml = t => {
    const n = yl(t);
    return n === 3 || n === 1;
};

let wl = null;

const bl = t => {
    wl || (wl = _o(t, "nextSibling"));
    gl || (gl = _o(t, "firstChild"));
    for (;t; ) {
        t = wl.call(t);
        if (t !== null) {
            const n = yl(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(ze)) {
                    return pn(t, Ue, wl, gl);
                }
                if (t.nodeValue?.startsWith(Xe)) {
                    return pn(t, [ Ue, Be ], wl, gl);
                }
                if (n?.startsWith(He)) {
                    for (;t && (t = wl.call(t)) && (yl(t) !== 8 || !t.nodeValue?.startsWith(Je)); ) {}
                }
            }
        }
    }
    return t;
};

function pn(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = vl(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const vl = So("parentNode");

let gl = null;

const _l = t => {
    gl || (gl = _o(t, "firstChild"));
    t = t && gl.call(t);
    if (t && yl(t) === 8 && t.nodeValue?.startsWith(ze)) {
        wl || (wl = _o(t, "nextSibling"));
        return pn(t, Ue, wl, gl);
    }
    for (;t && !ml(t); ) {
        t = bl(t);
    }
    return t;
};

const Sl = So("namespaceURI");

const kl = So("nodeName");

const El = So("ownerDocument");

const xl = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;jl(r) && mn(r); ) {
            r = bl(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = yl(r);
        let e = null;
        if (n === 3) {
            e = xo(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = Eo(r);
            Fo(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = bl(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        ql(e, (e, s) => {
            if (e() === 61) {
                n || (n = Zn(t.node));
                const e = s();
                n.Rn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Zn(t.node));
                $n(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function $n(t, n, e) {
    if (t[os]) {
        const s = t[os];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, os, {
            get() {
                const s = e.k(n);
                t[os] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, os, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const ql = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const Tl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        Lo(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(dr) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const Pl = (t, n) => {
    let e = Rl(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = Rl(e);
    }
    return !1;
};

const Rl = t => t.parent || t.slotParent;

const Al = t => {
    if (t === null || No(t)) {
        return null;
    }
    return t.node;
};

function yn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (Po(e)) {
                        const t = ne(e.node);
                        if (!t) {
                            return null;
                        }
                        return te(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (Mo(i)) {
            c.push(kn(ul(i)));
        } else if (No(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            if (r) {
                const t = Tl(r, i);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== qe && e !== "__scopedStyleIdPrefix__") {
                        const t = Co(i, e, null);
                        s.push(" " + e + "=" + kn(t));
                    }
                }
                i.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (Te[Co(i, qe, null) || "V"] || Te.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = fl(i);
            u && c.push("  " + yn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (Po(i)) {
            const s = ll(i);
            const l = [];
            on(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? Tl(r, i) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = Co(i, n, null);
                l.push(" " + n + "=" + kn(e));
            }
            const f = Al(i);
            if (f) {
                const t = El(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + kn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + kn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (Ao(i) || e) {
                const e = fl(i);
                e && c.push("  " + yn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const Ml = t => 48 <= t && t <= 57;

const Nl = t => 97 <= t && t <= 122;

function mn(t) {
    return !t.hasAttribute(dr) || t.nodeName === "STYLE" && (t.hasAttribute(Fe) || t.hasAttribute(Ce));
}

const Il = [];

const Cl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw ke(26, [ n ]);
};

const jl = t => t && typeof t == "object" && yl(t) === 1;

const Ol = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!No(t) || Co(t, Re, null) === null); ) {
            const e = t.slotParent;
            const s = No(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function wn(t, n) {
    To(n) && Po(n) && al(n);
    const e = n[os];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        bn(t, n);
    }
    e.clear();
}

function bn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Ms) {
            gn(s, n);
        } else if (s instanceof Ps) {
            vn(t, s, n);
        } else if (Js(s)) {
            const t = s[js];
            _n(t, n);
        } else if (t.dt.has(s)) {
            const e = t.dt.get(s);
            const o = Kl(e);
            _n(o, n);
        }
    }
    e.clear();
}

function vn(t, n, e) {
    const s = n.ct;
    s && s.has(e) && s.delete(e);
    if (n instanceof fi && !s?.size) {
        n._ = void 0;
        wn(t, n);
    }
}

function gn(t, n) {
    const e = t.ct;
    e && e.has(n) && e.delete(n);
    const s = t.$t;
    s && s.has(n) && s.delete(n);
    const o = t.yt;
    o && o.has(n) && o.delete(n);
    t.wt();
}

function _n(t, n) {
    const e = t?.ct;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Fl = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = eo();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Dl(6 | i, r, o._, t, void 0, null);
    s(c);
    const l = o.m;
    const {Lt: u} = o;
    const f = br(u, () => Ll(c, l, o._));
    mr(f) && (o.Lt = f);
};

const Ll = (t, n, e) => {
    const s = t.An;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = br(((t, n) => {
        const e = t.Mn;
        if (e) {
            return e;
        }
        const s = t.xn;
        if (!s) {
            return;
        }
        t.xn = null;
        try {
            const e = s();
            if (mr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Mn === s && (t.Mn = void 0);
                });
                t.Mn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = le(n.jt, e, "qTask");
        s.m = n;
        const i = t.bt.getFn(s, () => wn(n, t));
        const c = Ts(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.xn = () => {
                            t.xn = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    mr(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return wr(() => i(u), l, s => {
            if (mr(s)) {
                return s.then(() => {
                    t.An === r && (t.An = null);
                    return Ll(t, n, e);
                });
            }
            o(s);
        });
    });
    if (mr(i)) {
        r = i.finally(() => {
            t.An === r && (t.An = null);
        });
        t.An = r;
        return r;
    }
    return i;
};

class Dl extends ls {
    h;
    Jt;
    ft;
    bt;
    Ct;
    xn;
    Mn;
    An=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.h = t;
        this.Jt = n;
        this.ft = e;
        this.bt = s;
        this.Ct = o;
        this.xn = r;
    }
}

const Vl = t => t instanceof Dl;

function Sn(t, n) {
    const e = Zn(n);
    typeof this === "string" && Gc(Kc(e, this));
    const s = Yc[0];
    s.h |= 4;
    cn(e, s.ft, 1);
}

const Wl = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Ul = t => t instanceof Ps;

const Xl = (t, n) => {
    t.add(n);
};

const zl = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Bl = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Vl(e) ? o = e.bt : e instanceof Rs ? o = e.tn : s === ":" && (o = n.getHostProp(e, Re));
        o && n.serializationCtx.Mt.add(o);
    }
};

const Hl = (t, n, e) => {
    const s = ae;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Vl(o)) {
                o.h |= 4;
                cn(t, o.ft, 1);
            } else if (o instanceof Ps) {
                o.invalidate();
            } else if (r === ":") {
                cn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    Lt(o, n);
                    cn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof ai) {
                    const e = i.data;
                    const c = {
                        isConst: e.rt,
                        scopedStyleIdPrefix: e.O,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[bs];
                            if (!o) {
                                o = new Map;
                                s[bs] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(bs);
                        if (!n) {
                            n = new Map;
                            t.setProp(bs, n);
                        }
                        n.set(r, c);
                    }
                    cn(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Jl = t => ve(t) && typeof t[wc] === "function";

const Ql = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Yl = [];

function kn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Vl(t)) {
            return `Task(${kn(t.bt)})`;
        }
        if (xe(t)) {
            return `Qrl(${t.vt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Yl.includes(t)) {
                return "*";
            }
            try {
                Yl.push(t);
                if (Array.isArray(t)) {
                    return To(t) ? "(" + (Co(t, qe, null) || "vnode") + ")" : t.map(kn);
                }
                if (Ul(t)) {
                    return t instanceof fi ? "WrappedSignal" : t instanceof Rs ? "ComputedSignal" : "Signal";
                }
                if (ru(t)) {
                    return "Store";
                }
                if ($i(t)) {
                    return Gl(t);
                }
                if (To(t)) {
                    return "(" + (Co(t, qe, null) || "vnode") + ")";
                }
            } finally {
                Yl.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Gl = t => {
    if ($i(t)) {
        if (typeof t.type === "function") {
            const n = t.type[yf];
            if (n) {
                const [t] = n;
                return "Component(" + t.vt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + kn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Gl(e);
                    }
                } else {
                    n += Gl(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Kl = t => t[xs];

const Zl = t => t?.[Es] || null;

const tu = (t, n) => {
    const e = Kl(t);
    e && e.force(n);
};

const nu = (t, n) => {
    const e = Kl(t);
    if (e) {
        return (e.ct?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const eu = t => Zl(t) || t;

const ru = t => Es in t;

function En(t, n, e) {
    return new Proxy(n, new iu(e, t || null));
}

const su = (t, n, e) => {
    if (be(t) && e) {
        let s = e.dt.get(t);
        if (!s) {
            s = En(e, t, n);
            e.dt.set(t, s);
        }
        return s;
    }
    return t;
};

class iu {
    h;
    m;
    ct=void 0;
    constructor(t, n) {
        this.h = t;
        this.m = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Zl(this);
        Hl(this.m, this, Tn(n, t, this.ct));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === Es) {
                return t;
            }
            if (n === xs) {
                return this;
            }
            return t[n];
        }
        const e = Pc();
        const s = t[n];
        if (e) {
            if (this.m === null) {
                if (!e.m) {
                    return s;
                }
                this.m = e.m;
            }
            const o = e.Ft;
            o && xn(t, Array.isArray(t) ? qs : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && ve(s) && !Object.isFrozen(s) && !ru(s) && !Object.isFrozen(t)) {
            return su(s, this.h, this.m);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? eu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && qn(n, s, t, this);
        } else {
            qn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Hl(this.m, this, Tn(t, n, this.ct));
        return !0;
    }
    has(t, n) {
        if (n === Es) {
            return !0;
        }
        if (typeof n === "string") {
            const e = Pc();
            if (e) {
                const s = e.Ft;
                s && xn(t, Array.isArray(t) ? qs : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = Pc();
        const e = n?.Ft;
        e && xn(t, qs, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function xn(t, n, e, s) {
    const o = e.ct ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    Xl(r, s);
    zl(s, t);
    fe && Bl(s, e.m);
}

function qn(t, n, e, s) {
    e[t] = n;
    const o = Tn(e, t, s.ct);
    o && Hl(s.m, s, o);
}

function Tn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(qs);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const ou = Symbol();

const lu = [ void 0, null, !0, !1, "", Ls, Ds, Ss, qs, Fs, ji, Ni, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const uu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const cu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function Pn(t, n, e) {
    let s = n.vt;
    let o = n.gt;
    const r = Or();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => xe(t) && t.vt == Ee)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t._t(null, 0, e) + "";
    } else {
        o || (o = t.St(n.ot));
        if (!o) {
            throw ke(14, [ n.vt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.kt(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function Rn(t, n, e, s) {
    return ef(t, n, null, null, e, s);
}

function An(t, n) {
    const [e, s, o] = t.split("#");
    return Rn(e, s, o || null, n);
}

class fu {
    Nn;
    In=0;
    xt=[];
    Cn=0;
    jn=new Set;
    On=new Map;
    Fn;
    Ln=new Map;
    It;
    Dn=typeof Temporal !== "undefined";
    constructor(t) {
        this.Nn = t;
        this.It = t.It;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.It.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.It.write(rs) : s = !0;
            e(t[n], n);
        }
        this.It.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.It.write(t + rs + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.It.write(t + rs);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.It.write(e.slice(o, s));
                this.It.write("<\\/");
                o = s + 2;
            }
            this.It.write(o === 0 ? e : e.slice(o));
        } else {
            this.It.write(t + rs);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Nn.getSeenRef(t);
        const o = !e && this.On.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Nn.Vn(t, this.Fn, n);
            }
            s = this.Nn.kt(t, !0);
        }
        if (s.Fn) {
            if (this.Fn) {
                this.Nn.Wn(s);
            } else {
                this.Nn.Wn(s, n);
                t = this.Nn.Un[n];
            }
        }
        if (typeof o === "number") {
            this.xt[o] = s.Jt;
            this.On.delete(t);
        }
        const r = t instanceof mu ? t.Xn : s.Jt;
        if (!this.Fn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if ($c(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === Ss ? this.output(3, 7) : t === qs ? this.output(3, 8) : t === Fs ? this.output(3, 9) : t === ou && this.output(3, 0);
                break;

              case "function":
                if (t === ji) {
                    this.output(3, 10);
                } else if (t === Ni) {
                    this.output(3, 11);
                } else if (xe(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = Pn(this.Nn, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.Nn.kt(n)}#${this.Nn.kt(e)}${s ? "#" + s : ""}`;
                            const r = this.Ln.get(o);
                            if (r) {
                                const t = this.Nn.kt(r);
                                this.output(1, t);
                                return;
                            }
                            this.Ln.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!mf(t)) {
                        throw ke(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[yf];
                        this.Nn.zn.add(n.vt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === Ls) {
                    this.output(3, 5);
                } else if (t === Ds) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof mu) {
                    this.output(1, t.Xn);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.Fn;
                        this.Fn = e;
                        this.writeObjectValue(t);
                        this.Fn = n;
                    }
                }
                break;

              default:
                throw ke(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (Js(t)) {
            const n = t[Cs];
            this.output(38, [ $u(n), n.varProps, n.constProps, t[js].ct ]);
        } else if (t instanceof ai) {
            this.output(39, [ t.data.O, t.data.rt ]);
        } else if (t instanceof ks) {
            this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (ru(t)) {
            const n = Kl(t);
            const e = Zl(t);
            const s = n.h;
            const o = n.ct;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Nn.dt.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(35, i);
        } else if (Jl(t)) {
            const n = t[wc](t);
            if (mr(n)) {
                const t = this.resolvePromise(n, (t, n) => new au(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.Fn.Jt;
                this.Fn = this.Fn.Fn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        $c(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Nn.Bn(t)) {
            t.Hn.vnodeData[0] |= 16;
            this.output(11, t.Hn.id);
        } else if (t instanceof Ps) {
            if (t instanceof Ys) {
                const n = function e(t, n) {
                    if (n === Ss) {
                        return n;
                    }
                    return br(t.tn.resolved || t.tn.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && wc in n && (e = n[wc](n));
                        e === void 0 && (e = Ss);
                        return e;
                    });
                }(t, t.Kt);
                if (mr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new au(34, n, e, t.ct, t.tn));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.tn, t.ct, n ]);
                }
                return;
            }
            if (t instanceof fi) {
                this.output(31, [ ...Mn(this.Nn, t), t.h, t._, ...t.ct || [] ]);
            } else if (t instanceof Rs) {
                let n = t.Kt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const r = $c(t.Kt);
                const i = t instanceof Ms;
                const c = i && t.qt !== 0 ? t.qt : void 0;
                const l = i && t.pn !== 1 ? t.pn : void 0;
                const u = i && t.yn !== 0 ? t.yn : void 0;
                const f = i && t.h & -25 || void 0;
                o || r ? n = Ss : e ? n = t.Kt : s && (n = Ss);
                const a = [ t.tn, t.ct ];
                if (i) {
                    a.push(t.$t, t.yt, t.hn);
                    a.push(f || void 0);
                }
                n === Ss && c === void 0 && l === void 0 && u === void 0 || a.push(n === void 0 ? ou : n);
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 33 : 32, a);
            } else {
                const n = t.Kt;
                const e = [ n === void 0 ? ou : n ];
                t.ct && e.push(...t.ct);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (this.Dn && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.Dn && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Nn.Jn(t)) {
            const n = this.Nn.kt(t);
            this.Nn.Qn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                hu(e, t => this.Nn.kt(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    s && (s[0] |= 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if ($i(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof Dl) {
            const n = [ t.bt, t.h, t.Jt, t.ft, t.Ct ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (mr(t)) {
            const n = this.resolvePromise(t, (t, n) => new au(24, t, n));
            this.output(2, n);
        } else if (t instanceof au) {
            if (t.Yn === 34) {
                if (t.bt) {
                    this.output(34, [ t.bt, t.ct, t.Gn ]);
                } else {
                    if (!t.Kn) {
                        console.error(t.Gn);
                        throw ke(33);
                    }
                    {
                        const n = this.Fn.Jt;
                        this.Fn = this.Fn.Fn;
                        this.writeValue(t.Gn, n);
                    }
                }
            } else {
                this.output(24, [ t.Kn, t.Gn ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof pu) {
            const n = t.Zn;
            if (this.getSeenRefOrOutput(n, this.Fn.Jt, !0)) {
                let t = this.On.get(n);
                if (t === void 0) {
                    t = this.Cn++;
                    this.On.set(n, t);
                    this.xt[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!To(t)) {
                throw ke(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.Cn++;
        t.then(s => {
            this.jn.delete(t);
            this.xt[e] = this.Nn.kt(n(!0, s));
        }).catch(s => {
            this.jn.delete(t);
            this.xt[e] = this.Nn.kt(n(!1, s));
        });
        this.jn.add(t);
        return e;
    }
    async outputRoots() {
        this.It.write("[");
        const {Un: t} = this.Nn;
        for (;this.In < t.length || this.jn.size; ) {
            this.In !== 0 && this.It.write(rs);
            let n = !1;
            for (;this.In < t.length; this.In++) {
                n ? this.It.write(rs) : n = !0;
                this.writeValue(t[this.In], this.In);
            }
            if (this.jn.size) {
                try {
                    await Promise.race(this.jn);
                } catch {}
            }
        }
        if (this.xt.length) {
            let t = this.xt.length - 1;
            for (;t >= 0 && this.xt[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.It.write(rs);
                this.It.write(14 + rs);
                const n = t === this.xt.length - 1 ? this.xt : this.xt.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.It.write(t + "");
                });
            }
        }
        this.It.write("]");
    }
}

class au {
    Yn;
    Kn;
    Gn;
    ct;
    bt;
    constructor(t, n, e, s, o) {
        this.Yn = t;
        this.Kn = n;
        this.Gn = e;
        this.ct = s;
        this.bt = o;
    }
}

const hu = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (du(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === er && es(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const du = t => typeof t === "object" && t !== null && !es(t);

function Mn(t, n) {
    n.Et && n.Et[0] === "{" && (n.Et = `(${n.Et})`);
    const e = t._t(n.Et, n.ut.length, n.lt);
    return [ e, n.ut ];
}

class pu {
    Zn;
    constructor(t) {
        this.Zn = t;
    }
}

const $u = t => new pu(t);

let yu = () => !1;

class mu {
    Xn;
    constructor(t) {
        this.Xn = t;
    }
}

class wu {
    NodeConstructor;
    DomRefConstructor;
    St;
    Qn;
    dt;
    It;
    te=new Map;
    ne=new Map;
    ee=[];
    Un=[];
    Tt=new Set;
    Mt=new Set;
    At=new Set;
    zn=new Set;
    re;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.St = e;
        this.Qn = s;
        this.dt = o;
        this.It = r;
        this.re = new fu(this);
    }
    async Nt() {
        return await this.re.serialize();
    }
    getSeenRef(t) {
        return this.te.get(t);
    }
    Vn(t, n, e) {
        const s = {
            Jt: e,
            Fn: n
        };
        this.te.set(t, s);
        return s;
    }
    se(t) {
        const n = [];
        for (;t.Fn; ) {
            n.unshift(t.Jt);
            t = t.Fn;
        }
        n.unshift(t.Jt);
        return n.join(" ");
    }
    Wn(t, n) {
        const e = this.se(t);
        n === void 0 && (n = this.Un.length);
        this.Un[n] = new mu(e);
        t.Fn = null;
        t.Jt = n;
    }
    kt(t, n = !1) {
        let e = this.te.get(t);
        let s;
        if (e) {
            e.Fn && this.Wn(e);
            s = e.Jt;
        } else {
            s = this.Un.length;
            e = {
                Jt: s
            };
            this.te.set(t, e);
            this.Un.push(t);
        }
        return n ? e : s;
    }
    Jn(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Bn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    ie(t) {
        const n = this.te.get(t);
        return n && (n.Fn ? void 0 : n.Jt);
    }
    _t(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.ne.get(t);
        if (o === void 0) {
            o = this.ee.length;
            this.ne.set(t, o);
            if (s) {
                this.ee.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.ee.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const bu = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => {
                t.push(n);
            },
            toString: () => t.join("")
        };
    }
    yu = n ? t => t instanceof n : () => !1;
    return new wu(t, n, e, s, o, r);
};

const vu = (t, n) => t[n];

const gu = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        ru(t) && (t = Zl(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!gu(Nc(vu, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!gu(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Vl(t)) {
            return !0;
        }
        if (Js(t)) {
            return !0;
        }
        if (mr(t)) {
            return !0;
        }
        if ($i(t)) {
            return !0;
        }
        if (Jl(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof ai) {
            return !0;
        }
        if (yu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (xe(t) || mf(t) || t === ji || t === Ni) {
            return !0;
        }
    } else if (t === Fs || t === Ss || t === qs) {
        return !0;
    }
    return !1;
};

const _u = (t, n) => {
    let e = To(t) ? yn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (ve(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let Su = !1;

const ku = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (Su = !0);
            const n = `{${ve(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${_u(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = xu(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${ku(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${Eu(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = Su ? "" : `(${JSON.stringify(t).length} chars)`;
        Su = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const Eu = t => cu[t] || `Unknown(${t})`;

const xu = t => uu[t] || `Unknown(${t})`;

function Nn(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.xt = t[r + 1]);
    }
}

const qu = new WeakMap;

const Tu = new Map;

const Pu = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        if (!t.xt) {
            return Fs;
        }
        const s = t.xt[e];
        return s === -1 || s === void 0 ? Fs : t.k(s);

      case 14:
        return e;

      case 3:
        return lu[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t.k(s);
                const c = t.k(o);
                n = Rn(i, c, r || null, t);
            } else {
                n = Rn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new Dl(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return $f(null);

      case 30:
        return new Ps(t, 0);

      case 31:
        return new fi(t, null, null, null);

      case 32:
        return new Rs(t, null);

      case 33:
        return new Ms(t, null, void 0, {});

      case 34:
        return new Ys(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Pu(t, s, o);
            const i = su(r, 0, t);
            oc(s) && Tu.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new di(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        qu.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 27:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 38:
        return w(null);

      case 10:
        return In(t, e);

      case 11:
        const h = In(t, e);
        if (To(h)) {
            al(h);
            return Al(h);
        }
        throw ke(17, [ typeof h ]);

      case 39:
        return new ai({});

      case 40:
        return new ks(null, null, null, null);

      default:
        throw ke(18, [ n ]);
    }
};

function In(t, n) {
    return n ? t.rootVNode ? Uo(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ru = (t, n, e) => {
    let s = null;
    let o = null;
    if (Se(t)) {
        o = t;
    } else {
        if (!_e(t)) {
            throw ke(7, [ t ]);
        }
        s = t;
    }
    return ef(s, n, null, o, e);
};

const Au = (t, n, e) => ef(null, n, t, null, e);

const Mu = (t, n) => ef(null, t, null, null, n);

const Nu = (t, n, e) => {
    const s = Mu(t, e);
    return s;
};

const Iu = (t, n, e, s) => ef(t, e, null, n, s);

const Cu = (t, n, e, s, o) => {
    const r = Iu(t, n, e, o);
    r.oe(s);
    return r;
};

const ju = (t, n, e, s) => {
    const o = Ru(t, n, s);
    return o;
};

const Ou = (t, n, e, s) => {
    const o = Au(t, n, s);
    return o;
};

const Fu = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Lu = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Cn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Du = (t, n, e) => new fi(null, t, n, e || null);

class Vu {
    le;
    dt;
    jt;
    k;
    Dt;
    ue=0;
    ce=null;
    fe=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Dt = t;
        this.jt = n;
        this.le = ss;
        this.dt = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return jc(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return bu(t, n, e, this.setHostProp.bind(this), this.dt, s);
    }
    ht() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class Wu {}

function jn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function On(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === Wu) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    e === Promise ? o.push(await o.pop()) : await e.apply(t);
                    continue;
                }
                Fn(t, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                mr(n) && await n;
            }
        }
    })();
}

function Fn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (Ul(e)) {
            (function s(t, n) {
                const e = n instanceof fi ? n.it() : n;
                if (e instanceof Ms) {
                    const n = e.qt;
                    if (n && !(e.h & 256)) {
                        t.kt(e);
                        t.Tt.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(Ds);
            const o = t.getOrCreateLastNode();
            const r = e instanceof fi ? e.it() : e;
            n(t.closeFragment);
            n(() => jc(r, o, ".", t));
            n(Wu);
        } else if (mr(e)) {
            t.openFragment(Ds);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await On(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = Xs(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader && !t.Pt) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (Se(r)) {
                if (r === Ni) {
                    const e = o.key != null ? {
                        [nr]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === ji) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        const c = Xs(o, ar);
                        c && (i[ar] = c);
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const l = e.componentNode;
                        const u = t.getOrCreateLastNode();
                        const f = function a(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof fi) {
                                    return jc(n, t, ":", e);
                                }
                            }
                            return Xs(n, "name") || "";
                        }(l, o, t);
                        i[Ne] = f;
                        n(jn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const h = o.children || null;
                        const d = e.consumeChildrenForSlot(u, f) || h;
                        h && d !== h && t.addUnclaimedProjection(e, "", h);
                        n(d);
                        n(jn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = Ds;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Li) {
                    t.commentNode(Xs(o, "data") || "");
                } else if (r === Vi) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = Se(e) ? e({
                        async write(n) {
                            await On(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    mr(r) && n(Promise);
                } else if (r === Fi) {
                    t.htmlNode(Xs(o, "data"));
                } else if (r === Di) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (mf(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[yf];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Re, o);
                        s.setProp(er, r);
                        n.key !== null && s.setProp(nr, n.key);
                        return Ci(t, s, s, o, r);
                    })(t, o, r);
                    n(jn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (mr(l)) {
                        n(async () => {
                            const t = await l;
                            const e = _r(i.getProp(Fe));
                            n(t);
                            n(jn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = _r(i.getProp(Fe));
                        n(jn(s, t, c));
                    }
                } else {
                    const e = {
                        [nr]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Ci(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    mr(i) && n(Promise);
                }
            }
        }
    }
}

const Uu = () => Yc;

const Xu = async t => {
    const [n, e] = Yc;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = En(n.m, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const zu = (t, n) => {
    const {val: e, set: s, iCtx: o} = eo();
    if (e) {
        return e;
    }
    const r = ef(null, "_rsc", Xu, null, [ t, {} ], o.m);
    const i = Ks(r, {
        timeout: n?.timeout,
        container: o.m,
        concurrency: 0
    });
    i.p();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const Bu = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (mr(t)) {
        return t.then(n, s);
    }
    const o = Hu(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return mr(i) ? i.then(n, s) : n(i);
};

const Hu = t => t && t.__brand === "resource";

function Ln(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.vt.startsWith("_") || !n.Rt?.length && !s || (n = ef(null, "_run", F, null, [ n ]));
        return Pn(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (xe(o)) {
                i(c(o));
                Dn(t, n, o);
            } else if (o != null) {
                const e = Ln(t, n, o, s);
                e && i(e);
            }
        }
    } else if (xe(r)) {
        o = c(r);
        Dn(t, n, r);
    }
    return o;
}

function Dn(t, n, e) {
    const s = xr(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t.At.add(r);
        t.Mt.add(e);
    }
}

const Ju = (t, n, e) => {
    Gu(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const Qu = (t, n, e) => {
    Gu(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Yu = (t, n, e) => {
    Gu(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Gu = (t, n, e, s) => {
    const {isAdded: o, addEvent: r} = Ku();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const i = n[o];
                r(t + Er(i), e, s);
            }
        } else {
            r(t + Er(n), e, s);
        }
    }
};

const Ku = () => {
    const t = Ac();
    const n = t._;
    const e = n;
    let s = t.m.getHostProp(e, ur);
    if (s === null) {
        s = {};
        t.m.setHostProp(e, ur, s);
    }
    let o = t.m.getHostProp(e, cr);
    o === null && (o = 0);
    t.m.setHostProp(e, cr, o + 1);
    let r = t.m.getHostProp(e, fr);
    if (r === null) {
        r = [];
        t.m.setHostProp(e, fr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n, e) => {
            r[o] = !0;
            let i = s[t];
            i || (s[t] = i = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            i.qrls.push(n);
            e?.capture && (i.capture = !0);
            e?.preventdefault && (i.preventdefault = !0);
            e?.stoppropagation && (i.stoppropagation = !0);
        }
    };
};

const Zu = function(t, n) {
    if (!t.detail.files.some(t => n.getAttribute("data-qwik-inspector")?.startsWith(t))) {
        return;
    }
    if (typeof this === "string") {
        const t = Zn(n);
        Gc(Kc(t, this));
    }
    const e = Yc[0];
    const s = Zn(n);
    cn(s, e, 4);
    const o = n.ownerDocument;
    o.__hmrDone = o.__hmrT;
};

let tc;

function Vn() {
    const t = Pc();
    if (!t) {
        return;
    }
    tc ||= Au(Zu, "_hmr");
    const n = t._;
    const e = tc.w([ n ]);
    Qu("qHmr", e);
}

function Wn(t, n, e, s, o) {
    const r = qo();
    jo(r, Ne, o);
    r.parent = n;
    jo(n, o, r);
    jo(r, Re, e);
    jo(r, er, s);
    r.dirty = 4;
    sn(t, r, 1);
    return r;
}

function Un(t, n) {
    jo(t, Ae, n);
    t.flags |= 2048;
}

function Xn(t, n, e) {
    jo(n, er, e);
    cn(t, n, 4);
}

function zn(t, n, e, s) {
    jo(n, s, null);
    const o = [];
    Tt(t, o, e);
    Qo(o);
    if (e.flags & 2048) {
        const t = Co(e, Ae, null);
        t && t.replaceChildren();
        jo(e, Ae, null);
        e.flags &= -2049;
    }
}

let nc = Promise.resolve();

const ec = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const rc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !ec.has(t));
};

const sc = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = ic(t, s));
    switch (e) {
      case 4:
        ic(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!rc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 28:
        const o = n;
        const r = s;
        o.bt = r[0];
        o.h = r[1];
        o.Jt = r[2];
        o.ft = r[3];
        o.Ct = r[4];
        break;

      case 29:
        n[yf][0] = s[0];
        break;

      case 35:
        {
            const e = eu(n);
            const o = Tu.get(e);
            if (o) {
                Tu.delete(e);
                sc(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Kl(n);
            c.h = r;
            c.ct = i;
            Jn(c.ct, e);
            break;
        }

      case 30:
        {
            const t = n;
            const e = s;
            t.Kt = e[0];
            t.ct = new Set(e.slice(1));
            Hn(t.ct, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.lt = t.getSyncFn(o[0]);
            e.ut = o[1];
            e.Kt = Ss;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ct = new Set(o.slice(4));
            (function r(t) {
                if (t._ !== null && To(t._)) {
                    const n = t._;
                    const e = t.ct;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (_e(e)) {
                                const o = Co(n, e, null);
                                if (o !== null) {
                                    t.Kt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = fl(n);
                        e && n.firstChild === n.lastChild && Mo(e) && (t.Kt = ul(e));
                    }
                }
            })(e);
            Hn(e.ct, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.tn = e[0];
            e[1] && (t.ct = new Set(e[1]));
            e[2] && (t.$t = new Set(e[2]));
            e[3] && (t.yt = new Set(e[3]));
            e[4] && (t.hn = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.an = !0);
            const o = e.length > 6;
            o && (t.Kt = e[6]);
            t.Kt === Ss && (t.h |= 1);
            const r = e[7] ?? 0;
            t.expires = Math.abs(r);
            r < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.pn = e[8] ?? 1;
                t.$n = [];
            }
            t.yn = e[9] ?? 0;
            Hn(t.ct, t);
            Hn(t.$t, t);
            Hn(t.yt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const r = s;
            o.tn = r[0];
            const i = o.tn.resolve(t).catch(() => {});
            nc = nc.finally(() => i);
            r[1] && (o.ct = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Kt = r[2]);
            e !== 34 && o.Kt !== Ss && (o.h &= -2);
            Hn(o.ct, o);
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = qu.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 27:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (let t = 0; t < c.length; t++) {
            const n = c[t];
            i[l++] = n.charCodeAt(0);
        }
        break;

      case 38:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === Fs) {
            a = new di(Ni, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[Cs] = a;
        const h = u[js];
        h.ct = f[3];
        Jn(h.ct, u);
        break;

      case 39:
        {
            const t = n;
            t.data.O = s[0];
            t.data.rt = s[1];
            break;
        }

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = fe;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[os] ||= new Map;
                e[os].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw ke(16, [ e ]);
    }
};

const ic = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = Bn(t, n[s], n[s + 1]);
    }
    return e;
};

function Bn(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Pu(t, n, e);
    oc(n) && sc(t, s, n, e);
    return s;
}

function Hn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Jn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Hn(e, n);
        }
    }
}

const oc = t => t >= 23 || t === 4 || t === 5;

const lc = new WeakMap;

const uc = Symbol();

const cc = (t, n) => {
    if (!Array.isArray(n) || To(n) || (t => ve(t) && uc in t)(n)) {
        return n;
    }
    let e = lc.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new fc(t, n));
        lc.set(n, e);
    }
    return e;
};

class fc {
    m;
    ae;
    he;
    constructor(t, n) {
        this.m = t;
        this.ae = n;
        this.he = this.ae.length / 2;
    }
    get(t, n, e) {
        if (n === uc) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.he) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ae[o];
        const i = this.ae[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.m;
        const l = Pu(c, r, i);
        Reflect.set(t, n, l);
        this.ae[o] = 0;
        this.ae[o + 1] = l;
        oc(r) && sc(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === uc) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === uc) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ae.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ae[i] = 0;
        this.ae[i + 1] = e;
        return !0;
    }
}

async function Qn(t) {
    const n = bu(null, null, () => "", () => {}, new WeakMap);
    n.kt(t);
    await n.Nt();
    return "" + n.It;
}

function Yn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Kn(n);
    return Bn(e, n[0], n[1]);
}

function Gn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function Kn(t) {
    let n;
    const e = {
        k: t => Gn(t, n),
        getSyncFn: () => () => {},
        dt: new WeakMap,
        element: null,
        xt: null
    };
    Nn(t, e);
    n = cc(e, t);
    e.Ct = n;
    return e;
}

const ac = (t, n) => {
    const e = new WeakSet;
    return Nc(hc, t, e, "_", n);
};

const hc = (t, n, e, s) => {
    const o = eu(t);
    if (o == null) {
        return t;
    }
    if (pc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Ul(o)) {
            return t;
        }
        if (gu(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (mr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (ge(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw ke(3, [ o ]);
                    }
                    const r = o[t];
                    if (t !== s) {
                        throw ke(3, [ o ]);
                    }
                    hc(r, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof hs) {
                return t;
            }
            if (be(o)) {
                for (const [t, s] of Object.entries(o)) {
                    hc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw ke(3, [ i ]);
    }
    return t;
};

const dc = /*#__PURE__*/ new WeakSet;

const pc = t => {
    if (ve(t) || Se(t)) {
        return !dc.has(t) && !(mc in t);
    }
    return !0;
};

const $c = t => !!t && (ve(t) || typeof t === "function") && (dc.has(t) || mc in t);

const yc = t => {
    (ve(t) && t !== null || typeof t === "function") && dc.add(t);
    return t;
};

const mc = Symbol();

const wc = Symbol();

const bc = t => /*#__PURE__*/ Object.freeze({
    id: Er(t)
});

const vc = (t, n) => {
    const {val: e, set: s, iCtx: o} = eo();
    if (e !== void 0) {
        return;
    }
    o.m.setContext(o._, t, n);
    s(1);
};

const gc = (t, n) => {
    const {val: e, set: s, iCtx: o} = eo();
    if (e !== void 0) {
        return e;
    }
    const r = o.m.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(se(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw ke(8, [ t.id ]);
};

const _c = t => {
    const n = Rc();
    const e = n._;
    if (!e) {
        return;
    }
    return n.m?.resolveContext(e, t);
};

const Sc = /*#__PURE__*/ bc("qk-error");

const kc = t => 33 <= t && t <= 46;

const Ec = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && kc(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Zn(t) {
    const n = ne(t);
    if (!n) {
        throw ke(24);
    }
    return te(n);
}

function te(t) {
    const n = t;
    return n.qContainer ||= new xc(n);
}

function ne(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

class xc extends Vu {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    dt=new WeakMap;
    de;
    ce;
    xt=null;
    vNodeLocate=t => Uo(this.rootVNode, t);
    pe;
    $e;
    ye=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(He);
        if (!this.qContainer) {
            throw ke(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.fe = t.getAttribute(We);
        this.ce = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = Eo(this.element);
        this.pe = [];
        this.$e = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                const n = t.querySelectorAll('script[type="qwik/vnode"]');
                for (let t = 0; t < n.length; t++) {
                    const e = n[t];
                    const s = e.closest("[q\\:container]");
                    s.qVnodeData = e.textContent;
                    s.qVNodeRefs = new Map;
                }
                const e = t.querySelectorAll("[q\\:shadowroot]");
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    const s = n.shadowRoot;
                    s && d(s);
                }
            };
            d(t);
            const p = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const $ = t => {
                for (;t && (t = t.nextSibling) && p(t) === 0; ) {}
                return t;
            };
            const y = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let m = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;kc(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const v = s == e ? 2 : p(s);
                    if (v === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = $(e)); ) {
                            e = e.parentNode;
                        }
                        y(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (v === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while (p(t) !== 65);
                        w = null;
                    } else if (v === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = p(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (v === 9) {
                        w = s;
                        do {
                            w = $(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while (p(w) !== 8);
                        y(n, s, s, w, "", null);
                    } else if (v === 6) {
                        w = $(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && y(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((v & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    m = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = Ec(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            m === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const m = t.createTreeWalker(t, 129);
            y(m, null, m.firstChild(), null, "", null);
        }(n);
        this.de = Ve(n, this.ce) || Ls;
        this.me();
        t.setAttribute(He, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.xn();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.pe = JSON.parse(t.textContent);
            Nn(this.pe, this);
            this.$e = cc(this, this.pe);
        }
        this.we();
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    xn() {
        this.vNodeLocate = () => null;
        this.pe.length = 0;
        this.$e.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(He);
        t.ownerDocument.qVNodeData = void 0;
    }
    we() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Oe);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Rn(t, n) {
        this.$e[t] = n;
    }
    parseQRL(t) {
        const n = An(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, Sc);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Le);
        s == null && this.setHostProp(t, Le, s = []);
        ye(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Le);
            if (e != null && we(e, n.id, 0)) {
                return me(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (No(n)) {
                if (Co(n, Re, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        jo(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case rr:
          case er:
          case Re:
          case Le:
          case De:
          case ar:
            s = this.k;
            break;

          case sr:
          case cr:
            s = parseInt;
            break;
        }
        return Co(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (R(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => Gn(t, this.$e);
    getSyncFn(t) {
        const n = this.de[t];
        return n;
    }
    be(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Fe);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Fe, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.ye == null) {
            this.ye = new Set;
            const t = this.document.querySelectorAll(je);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.ye.add(e.getAttribute(Ce));
            }
        }
        if (!this.ye.has(n)) {
            this.ye.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Ce, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    me() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === dr) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Dt = {
            containerAttributes: t
        };
    }
}

let qc;

let eh;

if (fe) {
    const t = Lu();
    t && (eh = new t);
}

function ee(t) {
    if (eh) {
        const t = eh.getStore();
        if (t) {
            return t;
        }
    }
    if (qc === void 0) {
        const n = Pc();
        if (n && n.jt) {
            return n.jt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return qc;
}

function re(t, n) {
    if (eh) {
        return eh.run(t, n);
    }
    const e = qc;
    try {
        qc = t;
        return n();
    } finally {
        qc = e;
    }
}

let Tc;

const Pc = () => Tc;

const Rc = () => {
    const t = Pc();
    if (!t) {
        throw ke(9);
    }
    return t;
};

const Ac = () => {
    const t = Pc();
    if (!t || t.Ot !== Ze) {
        throw ke(10);
    }
    return t;
};

function se(t, n, ...e) {
    return ie.call(this, t, n, e);
}

function ie(t, n, e) {
    const s = Tc;
    try {
        Tc = t;
        return n.apply(this, e);
    } finally {
        Tc = s;
    }
}

const Mc = (t, n) => {
    const e = Zn(n);
    const s = Uo(e.rootVNode, n);
    const o = e.jt;
    o && function r(t) {
        if (eh) {
            eh.enterWith(t);
            return;
        }
        qc = t;
    }(o);
    const i = le(o, s, t);
    i.m = e;
    return i;
};

function oe(t, n, e) {
    const s = {
        _: n,
        Ot: Ze,
        Ft: void 0,
        jt: t,
        m: e,
        Lt: void 0
    };
    return s;
}

function le(t, n, e) {
    const s = t || (e && ve(e) && "locale" in e ? e.locale : void 0);
    const o = {
        _: n,
        Ot: e,
        Ft: void 0,
        jt: s,
        m: void 0
    };
    return o;
}

const Nc = (t, ...n) => {
    if (typeof t === "function") {
        if (!Tc) {
            return t(...n);
        }
        {
            const e = Tc.Ft;
            try {
                Tc.Ft = void 0;
                return t(...n);
            } finally {
                Tc.Ft = e;
            }
        }
    }
    if (Ul(t)) {
        return t.untrackedValue;
    }
    return eu(t);
};

const Ic = /*#__PURE__*/ oe(void 0, void 0, void 0);

const Cc = (t, n, e, s, o) => {
    const r = Ic.Ft;
    const i = Ic.m;
    try {
        Ic.Ft = m(n, e, o);
        Ic.m = s;
        return ie(Ic, t);
    } finally {
        Ic.Ft = r;
        Ic.m = i;
    }
};

const jc = (t, n, e, s, o) => {
    t instanceof fi && t._ !== n && n && (t._ = n);
    return Cc(() => t.value, n, e, s, o);
};

const Oc = () => Pc()?._;

const Fc = () => {
    const t = Pc();
    if (t) {
        return t.Ot;
    }
};

const Lc = () => {
    const t = Pc();
    if (t) {
        return t.m;
    }
};

const Dc = t => t;

const Vc = t => t.l || Promise.resolve();

let Wc = (t, n, e, s, o) => new Uc(t, n, e, s, o);

class Uc {
    gt;
    vt;
    ve;
    ge;
    m;
    constructor(t, n, e, s, o) {
        this.gt = t;
        this.vt = n;
        this.ve = e;
        this.ge = s;
        s && this._e(s);
        !o || s || typeof t !== "string" || e || (this.m = o);
        ae && t && ce(t, .8);
    }
    get ot() {
        return Ga(this.vt);
    }
    _e(t) {
        this.ge = t;
        mr(t) && t.then(t => this.ge = t, t => {
            console.error(`qrl ${this.vt} failed to load`, t);
            this.ge = null;
        });
    }
    Se() {
        if (this.ge != null) {
            return this.ge;
        }
        if (this.gt === "") {
            const t = this.m.ce;
            const n = this.m.element?.ownerDocument || document;
            const e = Ve(n, t);
            return this.ge = e[+this.vt];
        }
        ae && this.gt && ce(this.gt, 1);
        const t = this.vt;
        const n = this.ve ? this.ve().then(n => n[t]) : Or().importSymbol(this.m?.element, this.gt, t);
        this._e(n);
        return this.ge;
    }
}

ae && import.meta.hot && (t => {
    if (!ae || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Wc = (e, s, o, r, i) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, r, i);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let r = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.gt;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const i = t.gt;
            if (i) {
                t.gt = e(i, o);
                r = !0;
            }
            const c = t.ve?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const r = e(s, o);
                    return `import(${n}${r}${n})`;
                });
                if (n !== c) {
                    try {
                        t.ve = Function(`return (${n})`)();
                        r = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.vt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.vt}, cannot update it for HMR`, c);
                }
            }
            if (r) {
                t.ge = void 0;
                document.__hmrDone = document.__hmrT;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    });
})(Uc);

const Xc = Symbol();

const zc = t => t?.[Xc] ?? t;

class Bc {
    ke;
    resolved=void 0;
    Rt;
    m;
    constructor(t, n, e) {
        this.ke = t;
        if (n) {
            this.Rt = n;
            typeof n === "string" && (this.m = e);
        }
        t.ge == null || typeof this.Rt === "string" || mr(t.ge) || (this.resolved = tf(this, t.ge));
    }
}

const Hc = function(t, ...n) {
    const e = zc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = Pc();
    return Jc.call(e, s?.m).then(() => ie.call(t, s, e.resolved, n));
};

const Jc = async function(t) {
    const n = zc(this);
    return br(nf(n, t), () => n.resolved);
};

const Qc = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Xc].resolved;
        },
        set(t) {
            this[Xc].resolved = t;
        }
    },
    Rt: {
        get() {
            return this[Xc].Rt;
        },
        set(t) {
            this[Xc].Rt = t;
        }
    },
    m: {
        get() {
            return this[Xc].m;
        },
        set(t) {
            this[Xc].m = t;
        }
    },
    ke: {
        get() {
            return this[Xc].ke;
        }
    },
    gt: {
        get() {
            return this[Xc].ke.gt;
        }
    },
    vt: {
        get() {
            return this[Xc].ke.vt;
        }
    },
    ot: {
        get() {
            return this[Xc].ke.ot;
        }
    },
    dev: {
        get() {
            return this[Xc].ke.dev;
        }
    },
    Ee: {
        value: Hc
    },
    w: {
        value: function(t) {
            const n = zc(this);
            const e = new Bc(n.ke, t, n.Rt ? n.m : void 0);
            return rf(e);
        }
    },
    s: {
        value: function(t) {
            const n = zc(this);
            n.ke._e(t);
            n.resolved = tf(n, t);
        }
    },
    resolve: {
        value: Jc
    },
    getSymbol: {
        value: function() {
            return zc(this).ke.vt;
        }
    },
    getHash: {
        value: function() {
            return zc(this).ke.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = zc(this);
            Zc(t);
            return t.Rt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = zc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Jc.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return ie(t, e.resolved, o);
            };
            return s;
        }
    }
});

let Yc = null;

const Gc = t => {
    Yc = t;
};

const Kc = (t, n) => {
    const e = [];
    const s = n.split(" ");
    for (let n = 0; n < s.length; n++) {
        const o = s[n];
        e.push(t.k(o));
    }
    return e;
};

const Zc = t => {
    Yc = t.Rt;
    const n = t.m;
    if (typeof Yc === "string") {
        if (!n) {
            throw ke(13);
        }
        const e = nc;
        Yc = t.Rt = Kc(n, Yc);
        if (nc !== e) {
            return nc;
        }
    }
};

const tf = (t, n) => {
    if (typeof n !== "function" || !t.Rt) {
        return n;
    }
    return function e(...s) {
        Zc(t);
        return n.apply(this, s);
    };
};

const nf = (t, n) => {
    const e = t.ke;
    const s = typeof t.Rt === "string";
    s && !t.m && (t.m = n || Pc()?.m);
    if (t.resolved) {
        return;
    }
    const o = uf();
    const r = Pc();
    const i = e.Se();
    const c = br(i, n => {
        t.resolved = tf(t, n);
    });
    if (c) {
        const t = e.vt;
        of(t, r?._ instanceof ps ? r?._.node : void 0, o);
    }
    const l = s && t.m && Zc(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const ef = (t, n, e, s, o, r) => {
    const i = Wc(t, n, s, e, r);
    const c = new Bc(i, o, r);
    return rf(c);
};

const rf = t => {
    const n = async function(...t) {
        return Hc.call(n, this, ...t);
    };
    n[Xc] = t;
    Object.setPrototypeOf(n, Qc);
    return n;
};

const sf = /*#__PURE__*/ new Set;

const of = (t, n, e) => {
    if (!sf.has(t)) {
        sf.add(t);
        lf("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const lf = (t, n) => {
    Ka() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const uf = () => {
    if (Ka()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let cf = 0;

const ff = t => ef(null, "s" + cf++, t, null, null);

const af = ff;

const hf = t => t;

const df = t => ef("", Ee, t, null, null);

const pf = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return ef("", Ee, t, null, null);
};

const $f = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[yf] = [ t ];
        return Ei(i, n, null, n.children, s, r);
    }
    n[yf] = [ t ];
    return n;
};

const yf = Symbol();

const mf = t => typeof t == "function" && t[yf] !== void 0;

const wf = t => $f(af(t));

const bf = Qs(hf);

const vf = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const gf = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !is(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(He, "resumed");
    const s = Zn(t);
    s.Dt = e.serverData || {};
    const o = s.rootVNode;
    jo(o, vs, n);
    cn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            Tt(s, [], s.rootVNode);
        }
    };
};

const _f = (t, n) => {
    const {val: e, set: s, iCtx: o} = eo();
    if (e != null) {
        return e;
    }
    const r = Se(t) ? se(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.m;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = su(r, i, t);
        s(c);
        return c;
    }
};

const Sf = () => {
    const {val: t, set: n, iCtx: e} = eo();
    if (t != null) {
        return t;
    }
    const s = e.m.fe || "";
    const o = s ? Tr(s).substring(0, 3) : "";
    const r = e.m.getHostProp(e._, Re);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.ue++))(e.m) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function ue(t, n) {
    const e = Pc();
    return e?.m?.Dt[t] ?? n;
}

const kf = /*#__PURE__*/ new Map;

const Ef = (t, n) => {
    let e = kf.get(n);
    e || kf.set(n, e = xf(t, n));
    return e;
};

const xf = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = Af;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === sa) {
            r++;
            e = na;
        }
        const s = ha[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, m] = p;
            if (($ === l || $ === Df || $ === Vf && qf(l) || $ === Uf && Rf(l)) && (y === e || y === Df || y === Vf && qf(e) || y === Wf && !qf(e) && e !== Gf || y === Uf && Rf(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === Ff || m == Lf) {
                    if (m === Lf) {
                        if (c !== Mf || h()) {
                            if (!Tf(e)) {
                                const t = y == Wf ? 1 : y == Qf ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            Tf(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === Wf) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Af;
                        if (c === Nf) {
                            u(r - 1);
                            i++;
                        }
                    } while (Pf(c));
                } else {
                    o.push(c);
                    if (c === Nf && m === Af) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === If && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === Nf || h()) {
            return;
        }
        u(t);
        s.push(".", Me, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === Yf) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === Yf) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | oa) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(Nf) !== -1 || o.indexOf(Cf) !== -1;
    }
};

const qf = t => t >= Kf && t <= Zf || t >= na && t <= ea || t >= la && t <= ua || t >= 128 || t === ia || t === Yf;

const Tf = t => t === ta || t === Gf || t === ra || t === Jf || qf(t);

const Pf = t => t === jf || t === Cf || t === Of || t === Nf;

const Rf = t => t === Hf || t === Xf || t === zf || t === Bf;

const Af = 0;

const Mf = 2;

const Nf = 5;

const If = 6;

const Cf = 10;

const jf = 11;

const Of = 12;

const Ff = 17;

const Lf = 18;

const Df = 0;

const Vf = 1;

const Wf = 2;

const Uf = 3;

const Xf = 9;

const zf = 10;

const Bf = 13;

const Hf = 32;

const Jf = 35;

const Qf = 41;

const Yf = 45;

const Gf = 46;

const Kf = 48;

const Zf = 57;

const ta = 58;

const na = 65;

const ea = 90;

const ra = 91;

const sa = 92;

const ia = 95;

const oa = 32;

const la = 97;

const ua = 122;

const ca = 123;

const fa = 125;

const aa = /*@__PURE__*/ (() => [ [ Df, 39, 14 ], [ Df, 34, 15 ], [ Df, 47, 16, "*" ] ])();

const ha = /*@__PURE__*/ (() => [ [ [ Df, 42, Mf ], [ Df, ra, 7 ], [ Df, ta, If, ":", "before", "after", "first-letter", "first-line" ], [ Df, ta, Nf, "global" ], [ Df, ta, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Df, ta, 4 ], [ Df, Vf, 1 ], [ Df, Gf, 1 ], [ Df, Jf, 1 ], [ Df, 64, Cf, "keyframe" ], [ Df, 64, jf, "media", "supports", "container" ], [ Df, 64, Of ], [ Df, ca, 13 ], [ 47, 42, 16 ], [ Df, 59, Ff ], [ Df, fa, Ff ], [ Df, Qf, Ff ], ...aa ], [ [ Df, Wf, Lf ] ], [ [ Df, Wf, Lf ] ], [ [ Df, 40, Af ], [ Df, Wf, Lf ] ], [ [ Df, 40, 8 ], [ Df, Wf, Lf ] ], [ [ Df, 40, Af ], [ Df, Wf, Ff ] ], [ [ Df, Wf, Ff ] ], [ [ Df, 93, Lf ], [ Df, 39, 14 ], [ Df, 34, 15 ] ], [ [ Df, Qf, Ff ], ...aa ], [ [ Df, fa, Ff ], ...aa ], [ [ Df, fa, Ff ], [ Uf, Vf, 1 ], [ Df, ta, Nf, "global" ], [ Df, ca, 13 ], ...aa ], [ [ Df, ca, Af ], [ Df, 59, Ff ], ...aa ], [ [ Df, 59, Ff ], [ Df, ca, 9 ], ...aa ], [ [ Df, fa, Ff ], [ Df, ca, 13 ], [ Df, 40, 8 ], ...aa ], [ [ Df, 39, Ff ] ], [ [ Df, 34, Ff ] ], [ [ 42, 47, Ff ] ] ])();

const da = t => ({
    styleId: ma(t, t => t, !1)
});

const pa = /*#__PURE__*/ Qs(da);

const $a = t => ({
    scopeId: Me + ma(t, Ef, !0)
});

const ya = /*#__PURE__*/ Qs($a);

const ma = (t, n, e) => {
    let {val: s, set: o, iCtx: r, i} = eo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${Tr(t.ot)}-${n}`)(t, i);
    const l = r._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.m.be(n(t, c), c, l, e));
    }
    r.m.be(n(t.resolved, c), c, l, e);
    return c;
};

const wa = (t, n) => {
    t.resolve();
    return Gs(t, n);
};

const ba = (t, n) => io(wa, t, n);

const va = Qs(ba);

const ga = t => {
    t.resolve();
    return Zs(t);
};

const _a = t => io(ga, t);

const Sa = Qs(_a);

const ka = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = eo();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !Ka()) {
            e.h |= 32;
            Ea(e, i);
        }
        return;
    }
    let c;
    if (Ka()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        cn(r.m, r._, 1);
    }
    const l = new Dl(c, o, r._, t, void 0, null);
    s(l);
    Ea(l, i);
};

const Ea = (t, n) => {
    n === "intersection-observer" ? Ju("qvisible", xa(t)) : n === "document-ready" ? Qu("qinit", xa(t)) : n === "document-idle" && Qu("qidle", xa(t));
};

const xa = t => ef(null, "_task", Sn, null, [ t ]);

const qa = Qs(zu);

const Ta = /*#__PURE__*/ Qs(Fl);

const Pa = /*#__PURE__*/ Qs(ka);

const Ra = (t, n) => {
    t.resolve();
    return Ks(t, n);
};

const Aa = (t, n) => io(Ra, t, n);

const Ma = Qs(Aa);

const Na = () => {
    const t = _f({
        error: void 0
    });
    vc(Sc, t);
    return t;
};

const Ia = async ({track: t}) => {
    const n = Yc[0];
    t(() => n.items);
    const e = Pc();
    const s = e._;
    const o = e.m;
    cn(o, s, 128);
    const r = fe;
    r && await o.l;
};

const Ca = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Fl(/*#__PURE__*/ Au(Ia, "_eaT", [ t ]));
    return Oi;
};

const ja = /*#__PURE__*/ $f(
/*#__PURE__*/ Au(Ca, "_eaC"));

const Oa = /*#__PURE__*/ bc("qk-reveal");

const Fa = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: ti(0)
});

const La = () => {
    const t = Yc[0];
    if (t === null) {
        return !0;
    }
    const n = t.reveal;
    const e = t.item;
    const s = n.items;
    if (n.version.value < 0) {
        return !1;
    }
    switch (n.order) {
      case "together":
        for (let t = 0; t < s.length; t++) {
            if (s[t].boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < s.length; t++) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = s.length - 1; t >= 0; t--) {
            const n = s[t];
            if (n === e) {
                return !0;
            }
            if (n.boundary.pending.untrackedValue > 0) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const Da = ({cleanup: t}) => {
    const n = Yc[0];
    t(() => {
        if (!ae) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Va = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = io(Fa, t);
    vc(Oa, n);
    /*#__PURE__*/
    return ki(ji, null, null, null, 0, "u7_0");
};

const Wa = /*#__PURE__*/ $f(
/*#__PURE__*/ Au(Va, "_reC"));

const Ua = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || e !== null && !e.value && s.reveal.collapsed ? "none" : "contents"
});

const Xa = (t, n, e) => ({
    display: e !== null && !e.value || n.value !== "content" && !t.showStale ? "none" : "contents"
});

const za = ({track: t, cleanup: n}) => {
    const e = Yc[0], s = Yc[1], o = Yc[2], r = Yc[3];
    const i = t(e.pending);
    const c = ae;
    r !== null && c && r.reveal.version.value++;
    if (!c || i === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.pending.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const Ba = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = so("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return io(oo);
    })();
    const s = (t => {
        const n = gc(Oa, null);
        const e = io(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Fl(/*#__PURE__*/ Au(Da, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = ba(
    /*#__PURE__*/ Au(La, "_reR", [ s ]));
    Fl(
    /*#__PURE__*/ Au(za, "_suT", [ e, t, n, s ]));
    /*#__PURE__*/
    return ki(Ni, null, null, [ 
    /*#__PURE__*/ ki("div", {
        style: Du(Ua, [ t, n, o, s ], '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2===null||p2.value||!p3.reveal.collapsed)?"contents":"none"}')
    }, null, li(t, "fallback"), 1, null), 
    /*#__PURE__*/ ki("div", null, {
        style: Du(Xa, [ t, n, o ], '{display:(p2===null||p2.value)&&(p1.value==="content"||p0.showStale)?"contents":"none"}')
    }, 
    /*#__PURE__*/ ki(ji, {
        [ar]: e
    }, null, null, 3, "u6_0"), 1, null) ], 1, "u6_1");
};

const Ha = /*#__PURE__*/ $f(
/*#__PURE__*/ Au(Ba, "_suC"));

const Ja = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = Qa.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return ki("script", null, o, null, 0, "prefetch-service-worker");
};

const Qa = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const Ya = () => null;

globalThis.__qwik && ke(30, [ globalThis.__qwik, ss ]);

globalThis.__qwik = ss;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { ff as $, ja as Each, Ni as Fragment, mc as NoSerializeSymbol, Ya as PrefetchGraph, Ja as PrefetchServiceWorker, Ii as RenderOnce, Bu as Resource, Wa as Reveal, Li as SSRComment, Fi as SSRRaw, Vi as SSRStream, Di as SSRStreamBlock, wc as SerializerSymbol, Oi as SkipRender, ji as Slot, Ha as Suspense, Ns as _CONST_PROPS, xc as _DomContainer, os as _EFFECT_BACK_REF, Ls as _EMPTY_ARRAY, Ds as _EMPTY_OBJ, Os as _IMMUTABLE, Vu as _SharedContainer, ai as _SubscriptionData, Fs as _UNINITIALIZED, Is as _VAR_PROPS, Wn as _addProjection, Yc as _captures, v as _chk, Kn as _createDeserializeContainer, ef as _createQRL, Yn as _deserialize, ku as _dumpState, Ca as _eaC, Ia as _eaT, ln as _executeSsrChores, Du as _fnSignal, Lu as _getAsyncLocalStorage, Hs as _getConstProps, Lc as _getContextContainer, Fc as _getContextEvent, Oc as _getContextHostElement, Zn as _getDomContainer, ne as _getQContainerElement, Bs as _getVarProps, nu as _hasStoreEffects, Zu as _hmr, $i as _isJSXNode, ru as _isStore, Cn as _isStringifiable, Vl as _isTask, Dc as _jsxBranch, xi as _jsxC, Ti as _jsxQ, qi as _jsxS, ki as _jsxSorted, Ei as _jsxSplit, $e as _mapApp_findIndx, me as _mapArray_get, ye as _mapArray_set, Mu as _noopQrl, Nu as _noopQrlDEV, Nn as _preprocessState, pf as _qrlSync, Pn as _qrlToString, Iu as _qrlWithChunk, Cu as _qrlWithChunkDEV, Va as _reC, La as _reR, Da as _reT, Fu as _regSymbol, zn as _removeProjection, g as _res, _c as _resolveContextWithoutSequentialScope, zi as _restProps, Xu as _rsc, F as _run, Qn as _serialize, Ln as _setEvent, Un as _setProjectionTarget, Ba as _suC, za as _suT, Sn as _task, Xn as _updateProjectionProps, Vn as _useHmr, b as _val, ac as _verifySerializable, Lo as _vnode_ensureElementInflated, Tl as _vnode_getAttrKeys, ll as _vnode_getElementName, fl as _vnode_getFirstChild, Co as _vnode_getProp, Bo as _vnode_getVNodeForChildNode, el as _vnode_insertBefore, Po as _vnode_isElementVNode, Ao as _vnode_isMaterialized, Mo as _vnode_isTextVNode, No as _vnode_isVirtualVNode, qo as _vnode_newVirtual, il as _vnode_remove, jo as _vnode_setProp, yn as _vnode_toString, Vc as _waitUntilRendered, On as _walkJSX, li as _wrapProp, ci as _wrapSignal, wf as component$, $f as componentQrl, ei as createAsync$, Ks as createAsyncQrl, ni as createComputed$, Gs as createComputedQrl, bc as createContextId, _ as createElement, ri as createSerializer$, Zs as createSerializerQrl, ti as createSignal, bf as event$, hf as eventQrl, tu as forceStoreEffects, vf as getClientManifest, Zn as getDomContainer, ee as getLocale, Or as getPlatform, _ as h, Qs as implicit$FirstArg, Au as inlinedQrl, Ou as inlinedQrlDEV, he as isDev, Ul as isSignal, Ri as jsx, Ai as jsxDEV, Mi as jsxs, yc as noSerialize, Ru as qrl, ju as qrlDEV, gf as render, jr as setPlatform, df as sync$, Nc as untrack, eu as unwrapStore, Ma as useAsync$, Aa as useAsyncQrl, va as useComputed$, ba as useComputedQrl, io as useConstant, gc as useContext, vc as useContextProvider, Na as useErrorBoundary, Sf as useId, Uu as useLexicalScope, Ju as useOn, Qu as useOnDocument, Yu as useOnWindow, qa as useResource$, zu as useResourceQrl, Sa as useSerializer$, _a as useSerializerQrl, ue as useServerData, so as useSignal, _f as useStore, pa as useStyles$, da as useStylesQrl, ya as useStylesScoped$, $a as useStylesScopedQrl, Ta as useTask$, Fl as useTaskQrl, Pa as useVisibleTask$, ka as useVisibleTaskQrl, ss as version, re as withLocale };
